export const menseki = {
  soumenseki: {// ←このキー名は重要。storeにあるstatListのstatNameの[1]に対応している。
    column: "column01",
    statName: '総面積',
    unit: 'km2',
  },
  soumensekikouseihi: {
    column: "column02",
    statName: '総面積の構成比',
    unit: '％',
  },
  rinyamenseki: {
    column: "column03",
    statName: '林野面積',
    unit: 'ha',
  },
  rinyamensekitaisoumensekiwariai: {
    column: "column04",
    statName: '林野面積の対総面積割合',
    unit: '％',
  },
  kokuyuurinmenseki: {
    column: "column05",
    statName: '国有林面積',
    unit: 'ha',
  },
  kokuyuurinmensekinowariai: {
    column: "column06",
    statName: '国有林面積の割合',
    unit: '％',
  },
  tamenseki: {
    column: "column07",
    statName: '田面積',
    unit: 'ha',
  },
  hatamenseki: {
    column: "column08",
    statName: '畑面積',
    unit: 'ha',
  },
  tahatamensekiwariai: {
    column: "column09",
    statName: '田・畑対総面積割合',
    unit: '％',
  },
  takuchimenseki: {
    column: "column10",
    statName: '宅地面積',
    unit: 'ha',
  },
  takuchimensekiwariai: {
    column: "column11",
    statName: '宅地面積の総面積割合',
    unit: '％',
  },
  kazyuuchimenseki: {
    column: "column12",
    statName: '可住地面積',
    unit: 'he',
  },
  kazyuuchimensekiwariai: {
    column: "column13",
    statName: '可住地面積の対総面積割合',
    unit: '％',
  },
  data: [
    {
      "citycode": 45201,
      "cityname": "宮崎市",
      "column01": 643.67,
      "column02": 8.321181283,
      "column03": 35328,
      "column04": 54.8852673,
      "column05": 15988,
      "column06": 45.25588768,
      "column07": 5500,
      "column08": 3210,
      "column09": 13.53177871,
      "column10": 5642.5507,
      "column11": 8.766216695,
      "column12": 29210,
      "column13": 45.38039679
    },
    {
      "citycode": 45202,
      "cityname": "都城市",
      "column01": 653.36,
      "column02": 8.446450826,
      "column03": 35634,
      "column04": 54.53961063,
      "column05": 18266,
      "column06": 51.26003255,
      "column07": 6470,
      "column08": 6280,
      "column09": 19.51450961,
      "column10": 5745.4177,
      "column11": 8.793647759,
      "column12": 29361,
      "column13": 44.9384719
    },
    {
      "citycode": 45203,
      "cityname": "延岡市",
      "column01": 868.02,
      "column02": 11.22151378,
      "column03": 73118,
      "column04": 84.23538628,
      "column05": 9014,
      "column06": 12.32801772,
      "column07": 1860,
      "column08": 964,
      "column09": 3.253381258,
      "column10": 2116.4926,
      "column11": 2.438299348,
      "column12": 13495,
      "column13": 15.5468768
    },
    {
      "citycode": 45204,
      "cityname": "日南市",
      "column01": 536.11,
      "column02": 6.93067643,
      "column03": 42331,
      "column04": 78.95954189,
      "column05": 19955,
      "column06": 47.14039356,
      "column07": 1650,
      "column08": 1050,
      "column09": 5.036279868,
      "column10": 1436.4311,
      "column11": 2.6793589,
      "column12": 11740,
      "column13": 21.89849098
    },
    {
      "citycode": 45205,
      "cityname": "小林市",
      "column01": 562.95,
      "column02": 7.277656257,
      "column03": 41203,
      "column04": 73.1912248,
      "column05": 29431,
      "column06": 71.42926486,
      "column07": 2430,
      "column08": 4110,
      "column09": 11.61737277,
      "column10": 1794.5851,
      "column11": 3.187823253,
      "column12": 15191,
      "column13": 26.98463451
    },
    {
      "citycode": 45206,
      "cityname": "日向市",
      "column01": 336.94,
      "column02": 4.355863752,
      "column03": 26148,
      "column04": 77.60662452,
      "column05": 2015,
      "column06": 7.706134312,
      "column07": 954,
      "column08": 550,
      "column09": 4.463835218,
      "column10": 1475.3688,
      "column11": 4.378858517,
      "column12": 7496,
      "column13": 22.24794468
    },
    {
      "citycode": 45207,
      "cityname": "串間市",
      "column01": 295.16,
      "column02": 3.815743886,
      "column03": 22716,
      "column04": 76.96164792,
      "column05": 8330,
      "column06": 36.67018841,
      "column07": 1680,
      "column08": 1450,
      "column09": 10.60441794,
      "column10": 631.5581,
      "column11": 2.139714392,
      "column12": 7281,
      "column13": 24.66797669
    },
    {
      "citycode": 45208,
      "cityname": "西都市",
      "column01": 438.79,
      "column02": 5.672551362,
      "column03": 33705,
      "column04": 76.81350988,
      "column05": 11185,
      "column06": 33.18498739,
      "column07": 2770,
      "column08": 1220,
      "column09": 9.093188085,
      "column10": 974.2382,
      "column11": 2.220283507,
      "column12": 9898,
      "column13": 22.55748764
    },
    {
      "citycode": 45209,
      "cityname": "えびの市",
      "column01": 282.93,
      "column02": 3.657637952,
      "column03": 20548,
      "column04": 72.62573782,
      "column05": 11073,
      "column06": 53.8884563,
      "column07": 2500,
      "column08": 1290,
      "column09": 13.39553953,
      "column10": 1018.0756,
      "column11": 3.598330329,
      "column12": 8510,
      "column13": 30.07811119
    },
    {
      "citycode": 45341,
      "cityname": "三股町",
      "column01": 110.02,
      "column02": 1.422307028,
      "column03": 7871,
      "column04": 71.5415379,
      "column05": 2721,
      "column06": 34.56994029,
      "column07": 704,
      "column08": 667,
      "column09": 12.46137066,
      "column10": 659.983,
      "column11": 5.998754772,
      "column12": 3060,
      "column13": 27.81312489
    },
    {
      "citycode": 45361,
      "cityname": "高原町",
      "column01": 85.39,
      "column02": 1.103897447,
      "column03": 4122,
      "column04": 48.27263146,
      "column05": 1919,
      "column06": 46.55507035,
      "column07": 926,
      "column08": 1290,
      "column09": 25.95151657,
      "column10": 491.091,
      "column11": 5.751153531,
      "column12": 4205,
      "column13": 49.24464223
    },
    {
      "citycode": 45382,
      "cityname": "国富町",
      "column01": 130.63,
      "column02": 1.688747201,
      "column03": 7736,
      "column04": 59.22069969,
      "column05": 4266,
      "column06": 55.14477766,
      "column07": 1670,
      "column08": 838,
      "column09": 19.1992651,
      "column10": 606.1954,
      "column11": 4.640552706,
      "column12": 5315,
      "column13": 40.6874378
    },
    {
      "citycode": 45383,
      "cityname": "綾町",
      "column01": 95.19,
      "column02": 1.230589038,
      "column03": 7523,
      "column04": 79.03141086,
      "column05": 4177,
      "column06": 55.52306261,
      "column07": 327,
      "column08": 389,
      "column09": 7.521798508,
      "column10": 254.707,
      "column11": 2.675774766,
      "column12": 1941,
      "column13": 20.39079735
    },
    {
      "citycode": 45401,
      "cityname": "高鍋町",
      "column01": 43.8,
      "column02": 0.566233847,
      "column03": 838,
      "column04": 19.13242009,
      "column05": 45,
      "column06": 5.369928401,
      "column07": 560,
      "column08": 915,
      "column09": 33.67579909,
      "column10": 609.618,
      "column11": 13.91821918,
      "column12": 3532,
      "column13": 80.63926941
    },
    {
      "citycode": 45402,
      "cityname": "新富町",
      "column01": 61.53,
      "column02": 0.795442205,
      "column03": 1232,
      "column04": 20.02275313,
      "column05": 60,
      "column06": 4.87012987,
      "column07": 1110,
      "column08": 1060,
      "column09": 35.26734926,
      "column10": 574.885,
      "column11": 9.343165935,
      "column12": 4896,
      "column13": 79.570941
    },
    {
      "citycode": 45403,
      "cityname": "西米良村",
      "column01": 271.51,
      "column02": 3.510003465,
      "column03": 25983,
      "column04": 95.69813267,
      "column05": 416,
      "column06": 1.601046838,
      "column07": 63,
      "column08": 53,
      "column09": 0.427240249,
      "column10": 27.8351,
      "column11": 0.102519613,
      "column12": 1163,
      "column13": 4.283451807
    },
    {
      "citycode": 45404,
      "cityname": "木城町",
      "column01": 145.96,
      "column02": 1.886929048,
      "column03": 11911,
      "column04": 81.60454919,
      "column05": 8050,
      "column06": 67.58458568,
      "column07": 403,
      "column08": 307,
      "column09": 4.864346396,
      "column10": 236.2692,
      "column11": 1.618725678,
      "column12": 2542,
      "column13": 17.41573034
    },
    {
      "citycode": 45405,
      "cityname": "川南町",
      "column01": 90.12,
      "column02": 1.165045531,
      "column03": 3316,
      "column04": 36.79538393,
      "column05": 1505,
      "column06": 45.38600724,
      "column07": 1200,
      "column08": 2050,
      "column09": 36.06302708,
      "column10": 806.9994,
      "column11": 8.954720373,
      "column12": 5668,
      "column13": 62.89391922
    },
    {
      "citycode": 45406,
      "cityname": "都農町",
      "column01": 102.11,
      "column02": 1.320048815,
      "column03": 6360,
      "column04": 62.28577025,
      "column05": 4925,
      "column06": 77.43710692,
      "column07": 541,
      "column08": 967,
      "column09": 14.76838703,
      "column10": 416.1793,
      "column11": 4.075793752,
      "column12": 3794,
      "column13": 37.15600823
    },
    {
      "citycode": 45421,
      "cityname": "門川町",
      "column01": 120.52,
      "column02": 1.558048019,
      "column03": 10080,
      "column04": 83.64451083,
      "column05": 16,
      "column06": 0.158730159,
      "column07": 339,
      "column08": 103,
      "column09": 3.667745415,
      "column10": 341.3221,
      "column11": 2.832313501,
      "column12": 1927,
      "column13": 15.99037424
    },
    {
      "citycode": 45429,
      "cityname": "諸塚村",
      "column01": 187.56,
      "column02": 2.424721925,
      "column03": 17787,
      "column04": 94.83365323,
      "column05": 348,
      "column06": 1.956485073,
      "column07": 86,
      "column08": 104,
      "column09": 1.01300917,
      "column10": 45.5072,
      "column11": 0.242627426,
      "column12": 981,
      "column13": 5.230326296
    },
    {
      "citycode": 45430,
      "cityname": "椎葉村",
      "column01": 537.29,
      "column02": 6.945931131,
      "column03": 51485,
      "column04": 95.82348452,
      "column05": 8538,
      "column06": 16.58347091,
      "column07": 183,
      "column08": 159,
      "column09": 0.63652776,
      "column10": 64.5279,
      "column11": 0.120098829,
      "column12": 2202,
      "column13": 4.0983454
    },
    {
      "citycode": 45431,
      "cityname": "美郷町",
      "column01": 448.84,
      "column02": 5.802474881,
      "column03": 41374,
      "column04": 92.17984137,
      "column05": 1042,
      "column06": 2.518489873,
      "column07": 773,
      "column08": 381,
      "column09": 2.571072097,
      "column10": 198.6571,
      "column11": 0.44260115,
      "column12": 3477,
      "column13": 7.746635772
    },
    {
      "citycode": 45441,
      "cityname": "高千穂町",
      "column01": 237.54,
      "column02": 3.070849041,
      "column03": 19979,
      "column04": 84.10793972,
      "column05": 3002,
      "column06": 15.02577707,
      "column07": 1130,
      "column08": 836,
      "column09": 8.2765008,
      "column10": 434.7418,
      "column11": 1.830183548,
      "column12": 3302,
      "column13": 13.9008167
    },
    {
      "citycode": 45442,
      "cityname": "日之影町",
      "column01": 277.67,
      "column02": 3.589638179,
      "column03": 25091,
      "column04": 90.36266071,
      "column05": 7116,
      "column06": 28.36076681,
      "column07": 454,
      "column08": 323,
      "column09": 2.798285735,
      "column10": 122.6515,
      "column11": 0.441716786,
      "column12": 2341,
      "column13": 8.430871178
    },
    {
      "citycode": 45443,
      "cityname": "五ヶ瀬町",
      "column01": 171.73,
      "column02": 2.220076222,
      "column03": 15125,
      "column04": 88.07430268,
      "column05": 1108,
      "column06": 7.325619835,
      "column07": 472,
      "column08": 286,
      "column09": 4.413905549,
      "column10": 96.2951,
      "column11": 0.560735457,
      "column12": 1976,
      "column13": 11.50643452
    }
  ]
};

export const jinkou = {
  sousuu: {
    column: "column01",
    statName: '人口総数',
    unit: '人',
  },
  wariai: {
    column: "column02",
    statName: '県人口に占める人口割合',
    unit: '％',
  },
  otoko: {
    column: "column03",
    statName: '男',
    unit: '人',
  },
  onna: {
    column: "column04",
    statName: '女',
    unit: '人',
  },
  seihi: {
    column: "column05",
    statName: '性比',
    unit: '人',
  },
  data: [
    {
      "citycode": 45201,
      "cityname": "宮崎市",
      "column01": 399565,
      "column02": 36.72323913,
      "column03": 187654,
      "column04": 211911,
      "column05": 88.55321338
    },
    {
      "citycode": 45202,
      "cityname": "都城市",
      "column01": 162995,
      "column02": 14.98055226,
      "column03": 76635,
      "column04": 86360,
      "column05": 88.73899954
    },
    {
      "citycode": 45203,
      "cityname": "延岡市",
      "column01": 122372,
      "column02": 11.24697163,
      "column03": 57799,
      "column04": 64573,
      "column05": 89.50954733
    },
    {
      "citycode": 45204,
      "cityname": "日南市",
      "column01": 52556,
      "column02": 4.830319362,
      "column03": 24678,
      "column04": 27878,
      "column05": 88.52141474
    },
    {
      "citycode": 45205,
      "cityname": "小林市",
      "column01": 45174,
      "column02": 4.151854153,
      "column03": 20882,
      "column04": 24292,
      "column05": 85.96245678
    },
    {
      "citycode": 45206,
      "cityname": "日向市",
      "column01": 61098,
      "column02": 5.615397907,
      "column03": 28957,
      "column04": 32141,
      "column05": 90.09364986
    },
    {
      "citycode": 45207,
      "cityname": "串間市",
      "column01": 18012,
      "column02": 1.655447758,
      "column03": 8418,
      "column04": 9594,
      "column05": 87.74233896
    },
    {
      "citycode": 45208,
      "cityname": "西都市",
      "column01": 29927,
      "column02": 2.750532148,
      "column03": 14054,
      "column04": 15873,
      "column05": 88.54028854
    },
    {
      "citycode": 45209,
      "cityname": "えびの市",
      "column01": 18804,
      "column02": 1.728238932,
      "column03": 8858,
      "column04": 9946,
      "column05": 89.06092902
    },
    {
      "citycode": 45341,
      "cityname": "三股町",
      "column01": 25387,
      "column02": 2.33326961,
      "column03": 11789,
      "column04": 13598,
      "column05": 86.69657303
    },
    {
      "citycode": 45361,
      "cityname": "高原町",
      "column01": 8989,
      "column02": 0.826161442,
      "column03": 4303,
      "column04": 4686,
      "column05": 91.82671788
    },
    {
      "citycode": 45382,
      "cityname": "国富町",
      "column01": 19128,
      "column02": 1.758017139,
      "column03": 8902,
      "column04": 10226,
      "column05": 87.05261099
    },
    {
      "citycode": 45383,
      "cityname": "綾町",
      "column01": 7150,
      "column02": 0.657142542,
      "column03": 3326,
      "column04": 3824,
      "column05": 86.97698745
    },
    {
      "citycode": 45401,
      "cityname": "高鍋町",
      "column01": 20645,
      "column02": 1.897441648,
      "column03": 9737,
      "column04": 10908,
      "column05": 89.26475981
    },
    {
      "citycode": 45402,
      "cityname": "新富町",
      "column01": 16882,
      "column02": 1.551591664,
      "column03": 8216,
      "column04": 8666,
      "column05": 94.80729287
    },
    {
      "citycode": 45403,
      "cityname": "西米良村",
      "column01": 1067,
      "column02": 0.098065887,
      "column03": 521,
      "column04": 546,
      "column05": 95.42124542
    },
    {
      "citycode": 45404,
      "cityname": "木城町",
      "column01": 5168,
      "column02": 0.474980791,
      "column03": 2417,
      "column04": 2751,
      "column05": 87.85896038
    },
    {
      "citycode": 45405,
      "cityname": "川南町",
      "column01": 15657,
      "column02": 1.439004305,
      "column03": 7471,
      "column04": 8186,
      "column05": 91.26557537
    },
    {
      "citycode": 45406,
      "cityname": "都農町",
      "column01": 10254,
      "column02": 0.942425123,
      "column03": 4834,
      "column04": 5420,
      "column05": 89.18819188
    },
    {
      "citycode": 45421,
      "cityname": "門川町",
      "column01": 17866,
      "column02": 1.642029183,
      "column03": 8486,
      "column04": 9380,
      "column05": 90.46908316
    },
    {
      "citycode": 45429,
      "cityname": "諸塚村",
      "column01": 1651,
      "column02": 0.151740187,
      "column03": 809,
      "column04": 842,
      "column05": 96.0807601
    },
    {
      "citycode": 45430,
      "cityname": "椎葉村",
      "column01": 2695,
      "column02": 0.247692189,
      "column03": 1344,
      "column04": 1351,
      "column05": 99.48186528
    },
    {
      "citycode": 45431,
      "cityname": "美郷町",
      "column01": 5181,
      "column02": 0.476175596,
      "column03": 2492,
      "column04": 2689,
      "column05": 92.67385645
    },
    {
      "citycode": 45441,
      "cityname": "高千穂町",
      "column01": 12359,
      "column02": 1.135891563,
      "column03": 5912,
      "column04": 6447,
      "column05": 91.70156662
    },
    {
      "citycode": 45442,
      "cityname": "日之影町",
      "column01": 3829,
      "column02": 0.351915915,
      "column03": 1819,
      "column04": 2010,
      "column05": 90.49751244
    },
    {
      "citycode": 45443,
      "cityname": "五ヶ瀬町",
      "column01": 3725,
      "column02": 0.342357478,
      "column03": 1815,
      "column04": 1910,
      "column05": 95.02617801
    }
  ]
};

export const nenrei = {
  under15: {
    column: "column01",
    statName: '15歳未満人口',
    unit: '人',
  },
  under15kouseihi: {
    column: "column02",
    statName: '15歳未満人口の年齢３区分構成比',
    unit: '%',
  },
  over15under64: {
    column: "column03",
    statName: '15～64歳人口',
    unit: '人',
  },
  over15under64kouseihi: {
    column: "column04",
    statName: '15～64歳人口の年齢３区分構成比',
    unit: '%',
  },
  over65: {
    column: "column05",
    statName: '65歳以上人口',
    unit: '人',
  },
  over65kouseihi: {
    column: "column06",
    statName: '65歳以上人口の年齢３区分構成比',
    unit: '％',
  },
  nensyou: {
    column: "column07",
    statName: '年少人口指数',
    unit: '％',
  },
  rounen: {
    column: "column08",
    statName: '老年人口指数',
    unit: '％',
  },
  zyuuzoku: {
    column: "column09",
    statName: '従属人口指数',
    unit: '％',
  },
  rounenka: {
    column: "column10",
    statName: '老年化指数',
    unit: '％',
  },
  zoukaritu28to29: {
    column: "column11",
    statName: '平成２８年～２９年の人口増加率',
    unit: '％',
  },
  data: [
    {
      "citycode": 45201,
      "cityname": "宮崎市",
      "column01": 55451,
      "column02": 14.08594175,
      "column03": 231857,
      "column04": 58.89748058,
      "column05": 105940,
      "column06": 26.91141131,
      "column07": 23.91603445,
      "column08": 45.69195668,
      "column09": 69.60799113,
      "column10": 191.051559,
      "column11": -0.103505434
    },
    {
      "citycode": 45202,
      "cityname": "都城市",
      "column01": 22754,
      "column02": 13.9345467,
      "column03": 90411,
      "column04": 55.36768488,
      "column05": 49157,
      "column06": 30.10374054,
      "column07": 25.16729159,
      "column08": 54.3705965,
      "column09": 79.53788809,
      "column10": 216.0367408,
      "column11": -0.591589669
    },
    {
      "citycode": 45203,
      "cityname": "延岡市",
      "column01": 15728,
      "column02": 12.74007112,
      "column03": 66109,
      "column04": 53.54993398,
      "column05": 40166,
      "column06": 32.53545884,
      "column07": 23.79101181,
      "column08": 60.75723426,
      "column09": 84.54824608,
      "column10": 255.378942,
      "column11": -1.171035842
    },
    {
      "citycode": 45204,
      "cityname": "日南市",
      "column01": 6233,
      "column02": 11.71748693,
      "column03": 27092,
      "column04": 50.93055608,
      "column05": 19167,
      "column06": 36.03225928,
      "column07": 23.00679167,
      "column08": 70.74782224,
      "column09": 93.75461391,
      "column10": 307.5084229,
      "column11": -1.318111833
    },
    {
      "citycode": 45205,
      "cityname": "小林市",
      "column01": 5730,
      "column02": 12.58262149,
      "column03": 23314,
      "column04": 51.19567843,
      "column05": 15935,
      "column06": 34.99198489,
      "column07": 24.57750708,
      "column08": 68.34948958,
      "column09": 92.92699665,
      "column10": 278.0977312,
      "column11": -1.224471946
    },
    {
      "citycode": 45206,
      "cityname": "日向市",
      "column01": 8513,
      "column02": 13.88517371,
      "column03": 33525,
      "column04": 54.68112869,
      "column05": 18830,
      "column06": 30.71277116,
      "column07": 25.39299031,
      "column08": 56.16703952,
      "column09": 81.56002983,
      "column10": 221.1911195,
      "column11": -0.718232044
    },
    {
      "citycode": 45207,
      "cityname": "串間市",
      "column01": 2026,
      "column02": 11.14779355,
      "column03": 8493,
      "column04": 46.73159459,
      "column05": 7216,
      "column06": 39.70507318,
      "column07": 23.85493936,
      "column08": 84.96408807,
      "column09": 108.8190274,
      "column10": 356.1697927,
      "column11": -2.379274836
    },
    {
      "citycode": 45208,
      "cityname": "西都市",
      "column01": 3612,
      "column02": 11.92748407,
      "column03": 15565,
      "column04": 51.39847439,
      "column05": 10709,
      "column06": 35.36307499,
      "column07": 23.2059107,
      "column08": 68.80179891,
      "column09": 92.0077096,
      "column10": 296.4839424,
      "column11": -1.309194038
    },
    {
      "citycode": 45209,
      "cityname": "えびの市",
      "column01": 2067,
      "column02": 10.966099,
      "column03": 8954,
      "column04": 47.50384636,
      "column05": 7435,
      "column06": 39.4450634,
      "column07": 23.0846549,
      "column08": 83.03551485,
      "column09": 106.1201698,
      "column10": 359.7000484,
      "column11": -2.067600646
    },
    {
      "citycode": 45341,
      "cityname": "三股町",
      "column01": 4370,
      "column02": 17.37574553,
      "column03": 14073,
      "column04": 55.95626243,
      "column05": 6710,
      "column06": 26.67992048,
      "column07": 31.05236979,
      "column08": 47.67995452,
      "column09": 78.73232431,
      "column10": 153.5469108,
      "column11": 0.011818468
    },
    {
      "citycode": 45361,
      "cityname": "高原町",
      "column01": 1006,
      "column02": 11.0077689,
      "column03": 4465,
      "column04": 48.85654886,
      "column05": 3518,
      "column06": 38.49436481,
      "column07": 22.53079507,
      "column08": 78.79059351,
      "column09": 101.3213886,
      "column10": 349.7017893,
      "column11": -1.641317431
    },
    {
      "citycode": 45382,
      "cityname": "国富町",
      "column01": 2171,
      "column02": 11.21384298,
      "column03": 10209,
      "column04": 52.73243802,
      "column05": 6742,
      "column06": 34.82438017,
      "column07": 21.26555,
      "column08": 66.03976883,
      "column09": 87.30531884,
      "column10": 310.5481345,
      "column11": -1.228957968
    },
    {
      "citycode": 45383,
      "cityname": "綾町",
      "column01": 1031,
      "column02": 14.1874226,
      "column03": 3672,
      "column04": 50.52979221,
      "column05": 2447,
      "column06": 33.6727673,
      "column07": 28.07734205,
      "column08": 66.63943355,
      "column09": 94.7167756,
      "column10": 237.342386,
      "column11": -1.610017889
    },
    {
      "citycode": 45401,
      "cityname": "高鍋町",
      "column01": 2723,
      "column02": 13.12795295,
      "column03": 11403,
      "column04": 54.97541221,
      "column05": 6403,
      "column06": 30.86973291,
      "column07": 23.87968079,
      "column08": 56.15188985,
      "column09": 80.03157064,
      "column10": 235.1450606,
      "column11": -1.02119091
    },
    {
      "citycode": 45402,
      "cityname": "新富町",
      "column01": 2334,
      "column02": 13.6659055,
      "column03": 9471,
      "column04": 55.4540664,
      "column05": 5026,
      "column06": 29.42795246,
      "column07": 24.64364903,
      "column08": 53.06725795,
      "column09": 77.71090698,
      "column10": 215.3384747,
      "column11": -1.447752481
    },
    {
      "citycode": 45403,
      "cityname": "西米良村",
      "column01": 148,
      "column02": 13.57798165,
      "column03": 458,
      "column04": 42.01834862,
      "column05": 461,
      "column06": 42.29357798,
      "column07": 32.31441048,
      "column08": 100.6550218,
      "column09": 132.9694323,
      "column10": 311.4864865,
      "column11": -2.110091743
    },
    {
      "citycode": 45404,
      "cityname": "木城町",
      "column01": 791,
      "column02": 15.26437669,
      "column03": 2567,
      "column04": 49.53685836,
      "column05": 1810,
      "column06": 34.928599,
      "column07": 30.81417998,
      "column08": 70.51032333,
      "column09": 101.3245033,
      "column10": 228.8242731,
      "column11": -0.270165959
    },
    {
      "citycode": 45405,
      "cityname": "川南町",
      "column01": 2077,
      "column02": 13.08346457,
      "column03": 8296,
      "column04": 52.25826772,
      "column05": 5281,
      "column06": 33.26614173,
      "column07": 25.03616201,
      "column08": 63.65718419,
      "column09": 88.69334619,
      "column10": 254.2609533,
      "column11": -1.391862955
    },
    {
      "citycode": 45406,
      "cityname": "都農町",
      "column01": 1296,
      "column02": 12.53142526,
      "column03": 5203,
      "column04": 50.30941791,
      "column05": 3754,
      "column06": 36.29858828,
      "column07": 24.90870652,
      "column08": 72.1506823,
      "column09": 97.05938881,
      "column10": 289.6604938,
      "column11": -0.860485352
    },
    {
      "citycode": 45421,
      "cityname": "門川町",
      "column01": 2419,
      "column02": 13.46806971,
      "column03": 9727,
      "column04": 54.15622738,
      "column05": 5717,
      "column06": 31.83007628,
      "column07": 24.86892156,
      "column08": 58.77454508,
      "column09": 83.64346664,
      "column10": 236.3373295,
      "column11": -0.545535515
    },
    {
      "citycode": 45429,
      "cityname": "諸塚村",
      "column01": 184,
      "column02": 10.74138938,
      "column03": 753,
      "column04": 43.95796848,
      "column05": 714,
      "column06": 41.68126095,
      "column07": 24.43559097,
      "column08": 94.82071713,
      "column09": 119.2563081,
      "column10": 388.0434783,
      "column11": -3.619381203
    },
    {
      "citycode": 45430,
      "cityname": "椎葉村",
      "column01": 317,
      "column02": 11.54406409,
      "column03": 1216,
      "column04": 44.28259286,
      "column05": 1162,
      "column06": 42.31609614,
      "column07": 26.06907895,
      "column08": 95.55921053,
      "column09": 121.6282895,
      "column10": 366.5615142,
      "column11": -1.857246905
    },
    {
      "citycode": 45431,
      "cityname": "美郷町",
      "column01": 462,
      "column02": 8.671171171,
      "column03": 2133,
      "column04": 40.03378378,
      "column05": 2586,
      "column06": 48.53603604,
      "column07": 21.65963432,
      "column08": 121.2376934,
      "column09": 142.8973277,
      "column10": 559.7402597,
      "column11": -2.759009009
    },
    {
      "citycode": 45441,
      "cityname": "高千穂町",
      "column01": 1481,
      "column02": 11.76704275,
      "column03": 5908,
      "column04": 46.94104561,
      "column05": 4967,
      "column06": 39.46448435,
      "column07": 25.06770481,
      "column08": 84.07244414,
      "column09": 109.140149,
      "column10": 335.381499,
      "column11": -1.826991818
    },
    {
      "citycode": 45442,
      "cityname": "日之影町",
      "column01": 394,
      "column02": 10.13113911,
      "column03": 1735,
      "column04": 44.61301106,
      "column05": 1699,
      "column06": 43.68732322,
      "column07": 22.70893372,
      "column08": 97.92507205,
      "column09": 120.6340058,
      "column10": 431.2182741,
      "column11": -1.568123393
    },
    {
      "citycode": 45443,
      "cityname": "五ヶ瀬町",
      "column01": 507,
      "column02": 13.27920377,
      "column03": 1720,
      "column04": 45.04976427,
      "column05": 1498,
      "column06": 39.23520168,
      "column07": 29.47674419,
      "column08": 87.09302326,
      "column09": 116.5697674,
      "column10": 295.4635108,
      "column11": -2.435830278
    }
  ]
};

export const doutai = {
  syusseisuu: {
    column: "column01",
    statName: '出生数',
    unit: '人',
  },
  syusseiritu: {
    column: "column02",
    statName: '出生率',
    unit: '%',
  },
  shibousuu: {
    column: "column03",
    statName: '死亡数',
    unit: '人',
  },
  shizenzoukaritu: {
    column: "column04",
    statName: '自然増加率',
    unit: '%',
  },
  tennyuusyasuu: {
    column: "column05",
    statName: '転入者数',
    unit: '人',
  },
  kennaitennyuu: {
    column: "column06",
    statName: '県内からの転入',
    unit: '人',
  },
  kengaitennyuu: {
    column: "column07",
    statName: '県外からの転入',
    unit: '人',
  },
  tensyutusyasuu: {
    column: "column08",
    statName: '転出者数',
    unit: '人',
  },
  kennaitensyutu: {
    column: "column09",
    statName: '県内へ転出',
    unit: '人',
  },
  kengaitensyutu: {
    column: "column10",
    statName: '県外へ転出',
    unit: '人',
  },
  syakaizougenritu: {
    column: "column11",
    statName: '社会増減率',
    unit: '％',
  },
  data:
    [
      {
        "citycode": 45201,
        "cityname": "宮崎市",
        "column01": 3524,
        "column02": 8.810462549,
        "column03": 3894,
        "column04": -0.092504857,
        "column05": 14037,
        "column06": 5770,
        "column07": 8267,
        "column08": 14081,
        "column09": 4291,
        "column10": 9790,
        "column11": -0.011000578
      },
      {
        "citycode": 45202,
        "cityname": "都城市",
        "column01": 1390,
        "column02": 8.477418961,
        "column03": 2183,
        "column04": -0.483639801,
        "column05": 5936,
        "column06": 2067,
        "column07": 3869,
        "column08": 6113,
        "column09": 2152,
        "column10": 3961,
        "column11": -0.107949867
      },
      {
        "citycode": 45203,
        "cityname": "延岡市",
        "column01": 955,
        "column02": 7.712684337,
        "column03": 1627,
        "column04": -0.542714542,
        "column05": 3069,
        "column06": 1307,
        "column07": 1762,
        "column08": 3847,
        "column09": 1576,
        "column10": 2271,
        "column11": -0.6283213
      },
      {
        "citycode": 45204,
        "cityname": "日南市",
        "column01": 371,
        "column02": 6.966089602,
        "column03": 853,
        "column04": -0.905028353,
        "column05": 1629,
        "column06": 724,
        "column07": 905,
        "column08": 1849,
        "column09": 968,
        "column10": 881,
        "column11": -0.41308348
      },
      {
        "citycode": 45205,
        "cityname": "小林市",
        "column01": 358,
        "column02": 7.827874229,
        "column03": 716,
        "column04": -0.782787423,
        "column05": 1480,
        "column06": 708,
        "column07": 772,
        "column08": 1682,
        "column09": 872,
        "column10": 810,
        "column11": -0.441684524
      },
      {
        "citycode": 45206,
        "cityname": "日向市",
        "column01": 520,
        "column02": 8.449788755,
        "column03": 730,
        "column04": -0.341241469,
        "column05": 1914,
        "column06": 1071,
        "column07": 843,
        "column08": 2146,
        "column09": 1156,
        "column10": 990,
        "column11": -0.376990575
      },
      {
        "citycode": 45207,
        "cityname": "串間市",
        "column01": 121,
        "column02": 6.55791014,
        "column03": 381,
        "column04": -1.409137716,
        "column05": 509,
        "column06": 227,
        "column07": 282,
        "column08": 688,
        "column09": 351,
        "column10": 337,
        "column11": -0.97013712
      },
      {
        "citycode": 45208,
        "cityname": "西都市",
        "column01": 210,
        "column02": 6.925207756,
        "column03": 460,
        "column04": -0.824429495,
        "column05": 868,
        "column06": 539,
        "column07": 329,
        "column08": 1015,
        "column09": 639,
        "column10": 376,
        "column11": -0.484764543
      },
      {
        "citycode": 45209,
        "cityname": "えびの市",
        "column01": 114,
        "column02": 5.937190771,
        "column03": 370,
        "column04": -1.333263893,
        "column05": 841,
        "column06": 217,
        "column07": 624,
        "column08": 982,
        "column09": 311,
        "column10": 671,
        "column11": -0.734336753
      },
      {
        "citycode": 45341,
        "cityname": "三股町",
        "column01": 242,
        "column02": 9.53356445,
        "column03": 293,
        "column04": -0.200913962,
        "column05": 1097,
        "column06": 753,
        "column07": 344,
        "column08": 1043,
        "column09": 618,
        "column10": 425,
        "column11": 0.21273243
      },
      {
        "citycode": 45361,
        "cityname": "高原町",
        "column01": 54,
        "column02": 5.908742751,
        "column03": 175,
        "column04": -1.323996061,
        "column05": 273,
        "column06": 195,
        "column07": 78,
        "column08": 302,
        "column09": 225,
        "column10": 77,
        "column11": -0.31732137
      },
      {
        "citycode": 45382,
        "cityname": "国富町",
        "column01": 108,
        "column02": 5.576784055,
        "column03": 264,
        "column04": -0.805535475,
        "column05": 606,
        "column06": 408,
        "column07": 198,
        "column08": 688,
        "column09": 431,
        "column10": 257,
        "column11": -0.423422493
      },
      {
        "citycode": 45383,
        "cityname": "綾町",
        "column01": 48,
        "column02": 6.605201596,
        "column03": 92,
        "column04": -0.605476813,
        "column05": 231,
        "column06": 140,
        "column07": 91,
        "column08": 304,
        "column09": 189,
        "column10": 115,
        "column11": -1.004541076
      },
      {
        "citycode": 45401,
        "cityname": "高鍋町",
        "column01": 161,
        "column02": 7.718860869,
        "column03": 259,
        "column04": -0.469843705,
        "column05": 915,
        "column06": 586,
        "column07": 329,
        "column08": 1030,
        "column09": 662,
        "column10": 368,
        "column11": -0.551347205
      },
      {
        "citycode": 45402,
        "cityname": "新富町",
        "column01": 127,
        "column02": 7.413893754,
        "column03": 215,
        "column04": -0.513718622,
        "column05": 843,
        "column06": 398,
        "column07": 445,
        "column08": 1003,
        "column09": 454,
        "column10": 549,
        "column11": -0.934033859
      },
      {
        "citycode": 45403,
        "cityname": "西米良村",
        "column01": 8,
        "column02": 7.339449541,
        "column03": 17,
        "column04": -0.825688073,
        "column05": 56,
        "column06": 45,
        "column07": 11,
        "column08": 70,
        "column09": 46,
        "column10": 24,
        "column11": -1.28440367
      },
      {
        "citycode": 45404,
        "cityname": "木城町",
        "column01": 38,
        "column02": 7.333076032,
        "column03": 72,
        "column04": -0.656117329,
        "column05": 191,
        "column06": 131,
        "column07": 60,
        "column08": 171,
        "column09": 121,
        "column10": 50,
        "column11": 0.38595137
      },
      {
        "citycode": 45405,
        "cityname": "川南町",
        "column01": 89,
        "column02": 5.605239955,
        "column03": 228,
        "column04": -0.875425117,
        "column05": 476,
        "column06": 254,
        "column07": 222,
        "column08": 558,
        "column09": 351,
        "column10": 207,
        "column11": -0.516437839
      },
      {
        "citycode": 45406,
        "cityname": "都農町",
        "column01": 77,
        "column02": 7.444648555,
        "column03": 138,
        "column04": -0.58977086,
        "column05": 313,
        "column06": 211,
        "column07": 102,
        "column08": 341,
        "column09": 208,
        "column10": 133,
        "column11": -0.270714493
      },
      {
        "citycode": 45421,
        "cityname": "門川町",
        "column01": 140,
        "column02": 7.793364507,
        "column03": 245,
        "column04": -0.584502338,
        "column05": 622,
        "column06": 442,
        "column07": 180,
        "column08": 615,
        "column09": 408,
        "column10": 207,
        "column11": 0.038966823
      },
      {
        "citycode": 45429,
        "cityname": "諸塚村",
        "column01": 5,
        "column02": 2.918855809,
        "column03": 34,
        "column04": -1.692936369,
        "column05": 54,
        "column06": 38,
        "column07": 16,
        "column08": 87,
        "column09": 63,
        "column10": 24,
        "column11": -1.926444834
      },
      {
        "citycode": 45430,
        "cityname": "椎葉村",
        "column01": 20,
        "column02": 7.283321194,
        "column03": 46,
        "column04": -0.946831755,
        "column05": 91,
        "column06": 58,
        "column07": 33,
        "column08": 116,
        "column09": 80,
        "column10": 36,
        "column11": -0.910415149
      },
      {
        "citycode": 45431,
        "cityname": "美郷町",
        "column01": 25,
        "column02": 4.692192192,
        "column03": 149,
        "column04": -2.327327327,
        "column05": 164,
        "column06": 115,
        "column07": 49,
        "column08": 187,
        "column09": 145,
        "column10": 42,
        "column11": -0.431681682
      },
      {
        "citycode": 45441,
        "cityname": "高千穂町",
        "column01": 80,
        "column02": 6.35475415,
        "column03": 218,
        "column04": -1.096195091,
        "column05": 349,
        "column06": 195,
        "column07": 154,
        "column08": 441,
        "column09": 268,
        "column10": 173,
        "column11": -0.730796727
      },
      {
        "citycode": 45442,
        "cityname": "日之影町",
        "column01": 28,
        "column02": 7.197943445,
        "column03": 75,
        "column04": -1.208226221,
        "column05": 128,
        "column06": 78,
        "column07": 50,
        "column08": 142,
        "column09": 80,
        "column10": 62,
        "column11": -0.359897172
      },
      {
        "citycode": 45443,
        "cityname": "五ヶ瀬町",
        "column01": 17,
        "column02": 4.452592981,
        "column03": 65,
        "column04": -1.257202724,
        "column05": 151,
        "column06": 113,
        "column07": 38,
        "column08": 196,
        "column09": 129,
        "column10": 67,
        "column11": -1.178627554
      }
    ]
};
export const setai = {
  setaisuu: {
    column: "column01",
    statName: '世帯数',
    unit: '世帯',
  },
  zougensuu: {
    column: "column02",
    statName: '増減数',
    unit: '世帯',
  },
  zougenritu: {
    column: "column03",
    statName: '増減率',
    unit: '％',
  },
  setaijinin: {
    column: "column04",
    statName: '1世帯当たり人員',
    unit: '人',
  },
  kakusetaisuu: {
    column: "column05",
    statName: '核家族世帯数',
    unit: '世帯数',
  },
  kakuwariai: {
    column: "column06",
    statName: '核家族世帯割合（対一般世帯）',
    unit: '%',
  },
  kakuhuuhu: {
    column: "column07",
    statName: '夫婦のみの世帯',
    unit: '世帯数',
  },
  kakuhuuhuwariai: {
    column: "column08",
    statName: '夫婦のみの世帯割合（対一般世帯）',
    unit: '％',
  },
  kakuhuuhukodomo: {
    column: "column09",
    statName: '夫婦と子供からなる世帯',
    unit: '世帯',
  },
  kakuotoko: {
    column: "column10",
    statName: '男親と子供からなる世帯',
    unit: '世帯',
  },
  kakuhushi: {
    column: "column11",
    statName: 'うち父子世帯',
    unit: '世帯',
  },
  kakuonna: {
    column: "column12",
    statName: '女親と子供からなる世帯',
    unit: '世帯',
  },
  kakuboshi: {
    column: "column13",
    statName: 'うち母子世帯',
    unit: '世帯',
  },
  hushiboshi: {
    column: "column14",
    statName: '父子母子世帯割合（対一般世帯）',
    unit: '%',
  },
  tandokusetaisuu: {
    column: "column15",
    statName: '単独世帯数',
    unit: '世帯',
  },
  tandokuwariai: {
    column: "column16",
    statName: '単独世帯割合（対一般世帯）',
    unit: '％',
  },
  tandokuover65setaisuu: {
    column: "column17",
    statName: '65歳以上の単独世帯数',
    unit: '世帯',
  },
  tandokuover65wariai: {
    column: "column18",
    statName: '65歳以上の単独世帯割合（対一般世帯）',
    unit: '％',
  },
  over65setai: {
    column: "column19",
    statName: '65歳以上世帯員のいる一般世帯数',
    unit: '世帯',
  },
  over65setaiwariai: {
    column: "column20",
    statName: '65歳以上世帯員のいる一般世帯割合（対一般世帯）',
    unit: '％',
  },
  data:
    [
      {
        "citycode": 45201,
        "cityname": "宮崎市",
        "column01": 178581,
        "column02": 1522,
        "column03": 0.859600472,
        "column04": 2.237444073,
        "column05": 101121,
        "column06": 57.802586,
        "column07": 38861,
        "column08": 22.21364795,
        "column09": 45861,
        "column10": 1981,
        "column11": 345,
        "column12": 14418,
        "column13": 3621,
        "column14": 2.267037075,
        "column15": 62563,
        "column16": 35.76213831,
        "column17": 19977,
        "column18": 11.41921322,
        "column19": 64151,
        "column20": 36.66986773
      },
      {
        "citycode": 45202,
        "cityname": "都城市",
        "column01": 70488,
        "column02": 254,
        "column03": 0.361648205,
        "column04": 2.312379412,
        "column05": 42730,
        "column06": 61.24672123,
        "column07": 17518,
        "column08": 25.10929236,
        "column09": 18258,
        "column10": 917,
        "column11": 150,
        "column12": 6037,
        "column13": 1629,
        "column14": 2.549916149,
        "column15": 22445,
        "column16": 32.17137042,
        "column17": 10267,
        "column18": 14.71612654,
        "column19": 30654,
        "column20": 43.93767827
      },
      {
        "citycode": 45203,
        "cityname": "延岡市",
        "column01": 51893,
        "column02": 31,
        "column03": 0.059774016,
        "column04": 2.35816006,
        "column05": 29671,
        "column06": 57.4774321,
        "column07": 12028,
        "column08": 23.30014335,
        "column09": 12128,
        "column10": 728,
        "column11": 120,
        "column12": 4787,
        "column13": 1177,
        "column14": 2.512494673,
        "column15": 16347,
        "column16": 31.66673124,
        "column17": 7204,
        "column18": 13.95529038,
        "column19": 24858,
        "column20": 48.15388788
      },
      {
        "citycode": 45204,
        "cityname": "日南市",
        "column01": 22540,
        "column02": -74,
        "column03": -0.327230919,
        "column04": 2.331677019,
        "column05": 13470,
        "column06": 59.65456156,
        "column07": 5960,
        "column08": 26.39503986,
        "column09": 5202,
        "column10": 355,
        "column11": 47,
        "column12": 1953,
        "column13": 502,
        "column14": 2.431355182,
        "column15": 6954,
        "column16": 30.79716563,
        "column17": 3743,
        "column18": 16.57661647,
        "column19": 11854,
        "column20": 52.49778565
      },
      {
        "citycode": 45205,
        "cityname": "小林市",
        "column01": 19644,
        "column02": 28,
        "column03": 0.14274062,
        "column04": 2.299633476,
        "column05": 11664,
        "column06": 60.10821953,
        "column07": 5208,
        "column08": 26.8384437,
        "column09": 4618,
        "column10": 243,
        "column11": 46,
        "column12": 1595,
        "column13": 417,
        "column14": 2.385982994,
        "column15": 6076,
        "column16": 31.31151765,
        "column17": 3145,
        "column18": 16.2071631,
        "column19": 9639,
        "column20": 49.67276475
      },
      {
        "citycode": 45206,
        "cityname": "日向市",
        "column01": 25087,
        "column02": 55,
        "column03": 0.21971876,
        "column04": 2.435444653,
        "column05": 14956,
        "column06": 60.52855235,
        "column07": 5672,
        "column08": 22.95519851,
        "column09": 6557,
        "column10": 407,
        "column11": 65,
        "column12": 2320,
        "column13": 631,
        "column14": 2.816787405,
        "column15": 7163,
        "column16": 28.98943705,
        "column17": 3103,
        "column18": 12.55817718,
        "column19": 11197,
        "column20": 45.3154721
      },
      {
        "citycode": 45207,
        "cityname": "串間市",
        "column01": 7854,
        "column02": -67,
        "column03": -0.845852796,
        "column04": 2.293353705,
        "column05": 4632,
        "column06": 58.47008331,
        "column07": 2250,
        "column08": 28.40191871,
        "column09": 1620,
        "column10": 116,
        "column11": 16,
        "column12": 646,
        "column13": 143,
        "column14": 2.007068922,
        "column15": 2526,
        "column16": 31.8858874,
        "column17": 1572,
        "column18": 19.84347387,
        "column19": 4459,
        "column20": 56.28629134
      },
      {
        "citycode": 45208,
        "cityname": "西都市",
        "column01": 12011,
        "column02": 13,
        "column03": 0.108351392,
        "column04": 2.49163267,
        "column05": 7230,
        "column06": 60.42624321,
        "column07": 2865,
        "column08": 23.94483911,
        "column09": 3035,
        "column10": 196,
        "column11": 28,
        "column12": 1134,
        "column13": 241,
        "column14": 2.248223987,
        "column15": 3272,
        "column16": 27.34642708,
        "column17": 1903,
        "column18": 15.90472211,
        "column19": 6584,
        "column20": 55.02716256
      },
      {
        "citycode": 45209,
        "cityname": "えびの市",
        "column01": 8535,
        "column02": -54,
        "column03": -0.628711142,
        "column04": 2.203163445,
        "column05": 4898,
        "column06": 57.27985031,
        "column07": 2393,
        "column08": 27.98503099,
        "column09": 1740,
        "column10": 129,
        "column11": 17,
        "column12": 636,
        "column13": 123,
        "column14": 1.637235411,
        "column15": 2831,
        "column16": 33.10723892,
        "column17": 1719,
        "column18": 20.10291194,
        "column19": 4859,
        "column20": 56.8237633
      },
      {
        "citycode": 45341,
        "cityname": "三股町",
        "column01": 10107,
        "column02": 62,
        "column03": 0.617222499,
        "column04": 2.511823489,
        "column05": 6894,
        "column06": 69.39104177,
        "column07": 2625,
        "column08": 26.42174132,
        "column09": 3246,
        "column10": 137,
        "column11": 23,
        "column12": 886,
        "column13": 289,
        "column14": 3.140412682,
        "column15": 2448,
        "column16": 24.64016105,
        "column17": 1276,
        "column18": 12.84348264,
        "column19": 4020,
        "column20": 40.46300956
      },
      {
        "citycode": 45361,
        "cityname": "高原町",
        "column01": 3871,
        "column02": -23,
        "column03": -0.590652286,
        "column04": 2.322138982,
        "column05": 2402,
        "column06": 61.62134428,
        "column07": 1162,
        "column08": 29.81015906,
        "column09": 837,
        "column10": 81,
        "column11": 20,
        "column12": 322,
        "column13": 58,
        "column14": 2.001026167,
        "column15": 1105,
        "column16": 28.3478707,
        "column17": 740,
        "column18": 18.98409441,
        "column19": 2253,
        "column20": 57.79887122
      },
      {
        "citycode": 45382,
        "cityname": "国富町",
        "column01": 7628,
        "column02": 21,
        "column03": 0.276061522,
        "column04": 2.507603566,
        "column05": 5045,
        "column06": 66.89207107,
        "column07": 2101,
        "column08": 27.85733227,
        "column09": 2106,
        "column10": 137,
        "column11": 27,
        "column12": 701,
        "column13": 154,
        "column14": 2.399893927,
        "column15": 1813,
        "column16": 24.03871652,
        "column17": 1121,
        "column18": 14.86343145,
        "column19": 3949,
        "column20": 52.36011668
      },
      {
        "citycode": 45383,
        "cityname": "綾町",
        "column01": 2908,
        "column02": -20,
        "column03": -0.683060109,
        "column04": 2.458734525,
        "column05": 1985,
        "column06": 68.28345373,
        "column07": 837,
        "column08": 28.79256966,
        "column09": 848,
        "column10": 46,
        "column11": 7,
        "column12": 254,
        "column13": 52,
        "column14": 2.029583763,
        "column15": 686,
        "column16": 23.59821121,
        "column17": 427,
        "column18": 14.68868249,
        "column19": 1514,
        "column20": 52.08118335
      },
      {
        "citycode": 45401,
        "cityname": "高鍋町",
        "column01": 8636,
        "column02": -33,
        "column03": -0.380666744,
        "column04": 2.39057434,
        "column05": 5163,
        "column06": 59.70856945,
        "column07": 2037,
        "column08": 23.55730311,
        "column09": 2153,
        "column10": 122,
        "column11": 24,
        "column12": 851,
        "column13": 208,
        "column14": 2.683011449,
        "column15": 2663,
        "column16": 30.79680814,
        "column17": 1096,
        "column18": 12.67491616,
        "column19": 3954,
        "column20": 45.72684168
      },
      {
        "citycode": 45402,
        "cityname": "新富町",
        "column01": 6358,
        "column02": 6,
        "column03": 0.094458438,
        "column04": 2.655237496,
        "column05": 4183,
        "column06": 66.01957071,
        "column07": 1573,
        "column08": 24.82638889,
        "column09": 1953,
        "column10": 116,
        "column11": 20,
        "column12": 541,
        "column13": 133,
        "column14": 2.414772727,
        "column15": 1457,
        "column16": 22.99558081,
        "column17": 738,
        "column18": 11.64772727,
        "column19": 3004,
        "column20": 47.41161616
      },
      {
        "citycode": 45403,
        "cityname": "西米良村",
        "column01": 515,
        "column02": 1,
        "column03": 0.194552529,
        "column04": 2.07184466,
        "column05": 258,
        "column06": 50.78740157,
        "column07": 142,
        "column08": 27.95275591,
        "column09": 75,
        "column10": 3,
        "column11": 1,
        "column12": 38,
        "column13": 8,
        "column14": 1.771653543,
        "column15": 199,
        "column16": 39.17322835,
        "column17": 111,
        "column18": 21.8503937,
        "column19": 307,
        "column20": 60.43307087
      },
      {
        "citycode": 45404,
        "cityname": "木城町",
        "column01": 1979,
        "column02": 13,
        "column03": 0.661241099,
        "column04": 2.611419909,
        "column05": 1245,
        "column06": 63.91170431,
        "column07": 504,
        "column08": 25.87268994,
        "column09": 521,
        "column10": 40,
        "column11": 7,
        "column12": 180,
        "column13": 44,
        "column14": 2.618069815,
        "column15": 456,
        "column16": 23.40862423,
        "column17": 302,
        "column18": 15.50308008,
        "column19": 1086,
        "column20": 55.74948665
      },
      {
        "citycode": 45405,
        "cityname": "川南町",
        "column01": 6047,
        "column02": 59,
        "column03": 0.985303941,
        "column04": 2.589217794,
        "column05": 3588,
        "column06": 60.67985794,
        "column07": 1388,
        "column08": 23.47370201,
        "column09": 1548,
        "column10": 104,
        "column11": 22,
        "column12": 548,
        "column13": 120,
        "column14": 2.401488246,
        "column15": 1454,
        "column16": 24.58988669,
        "column17": 784,
        "column18": 13.25892102,
        "column19": 3126,
        "column20": 52.8665652
      },
      {
        "citycode": 45406,
        "cityname": "都農町",
        "column01": 3991,
        "column02": 37,
        "column03": 0.935761254,
        "column04": 2.569280882,
        "column05": 2377,
        "column06": 60.51425662,
        "column07": 964,
        "column08": 24.54175153,
        "column09": 953,
        "column10": 57,
        "column11": 7,
        "column12": 403,
        "column13": 87,
        "column14": 2.393075356,
        "column15": 945,
        "column16": 24.05804481,
        "column17": 613,
        "column18": 15.60590631,
        "column19": 2339,
        "column20": 59.54684318
      },
      {
        "citycode": 45421,
        "cityname": "門川町",
        "column01": 6888,
        "column02": 73,
        "column03": 1.071166544,
        "column04": 2.593786295,
        "column05": 4276,
        "column06": 62.88235294,
        "column07": 1601,
        "column08": 23.54411765,
        "column09": 1928,
        "column10": 113,
        "column11": 16,
        "column12": 634,
        "column13": 151,
        "column14": 2.455882353,
        "column15": 1629,
        "column16": 23.95588235,
        "column17": 857,
        "column18": 12.60294118,
        "column19": 3438,
        "column20": 50.55882353
      },
      {
        "citycode": 45429,
        "cityname": "諸塚村",
        "column01": 696,
        "column02": 2,
        "column03": 0.288184438,
        "column04": 2.372126437,
        "column05": 340,
        "column06": 49.56268222,
        "column07": 178,
        "column08": 25.94752187,
        "column09": 112,
        "column10": 6,
        "column11": 1,
        "column12": 44,
        "column13": 5,
        "column14": 0.874635569,
        "column15": 191,
        "column16": 27.8425656,
        "column17": 93,
        "column18": 13.55685131,
        "column19": 435,
        "column20": 63.41107872
      },
      {
        "citycode": 45430,
        "cityname": "椎葉村",
        "column01": 1121,
        "column02": 0,
        "column03": 0,
        "column04": 2.404103479,
        "column05": 577,
        "column06": 51.28888889,
        "column07": 289,
        "column08": 25.68888889,
        "column09": 194,
        "column10": 22,
        "column11": 1,
        "column12": 72,
        "column13": 5,
        "column14": 0.533333333,
        "column15": 319,
        "column16": 28.35555556,
        "column17": 164,
        "column18": 14.57777778,
        "column19": 735,
        "column20": 65.33333333
      },
      {
        "citycode": 45431,
        "cityname": "美郷町",
        "column01": 2263,
        "column02": -34,
        "column03": -1.480191554,
        "column04": 2.289438798,
        "column05": 1264,
        "column06": 54.3655914,
        "column07": 680,
        "column08": 29.24731183,
        "column09": 384,
        "column10": 35,
        "column11": 1,
        "column12": 165,
        "column13": 23,
        "column14": 1.032258065,
        "column15": 701,
        "column16": 30.15053763,
        "column17": 483,
        "column18": 20.77419355,
        "column19": 1628,
        "column20": 70.02150538
      },
      {
        "citycode": 45441,
        "cityname": "高千穂町",
        "column01": 4606,
        "column02": -41,
        "column03": -0.882289649,
        "column04": 2.683239253,
        "column05": 2328,
        "column06": 49.88215127,
        "column07": 1036,
        "column08": 22.1984144,
        "column09": 814,
        "column10": 76,
        "column11": 5,
        "column12": 402,
        "column13": 75,
        "column14": 1.714163274,
        "column15": 1270,
        "column16": 27.21234198,
        "column17": 683,
        "column18": 14.63466895,
        "column19": 2991,
        "column20": 64.08827941
      },
      {
        "citycode": 45442,
        "cityname": "日之影町",
        "column01": 1492,
        "column02": 1,
        "column03": 0.067069081,
        "column04": 2.566353887,
        "column05": 784,
        "column06": 52.65278711,
        "column07": 377,
        "column08": 25.31900604,
        "column09": 244,
        "column10": 31,
        "column11": 2,
        "column12": 132,
        "column13": 13,
        "column14": 1.007387508,
        "column15": 357,
        "column16": 23.9758227,
        "column17": 226,
        "column18": 15.17797179,
        "column19": 1049,
        "column20": 70.44996642
      },
      {
        "citycode": 45443,
        "cityname": "五ヶ瀬町",
        "column01": 1272,
        "column02": -7,
        "column03": -0.54730258,
        "column04": 2.928459119,
        "column05": 545,
        "column06": 42.84591195,
        "column07": 260,
        "column08": 20.44025157,
        "column09": 180,
        "column10": 21,
        "column11": 0,
        "column12": 84,
        "column13": 9,
        "column14": 0.70754717,
        "column15": 315,
        "column16": 24.76415094,
        "column17": 177,
        "column18": 13.91509434,
        "column19": 888,
        "column20": 69.81132075
      }
    ]
};

export const jigyousyosuu = {
  sousuu: {
    column: "column01",
    statName: '事業所総数',
    unit: '所',
  },
  dai1suu: {
    column: "column02",
    statName: '第1次産業事業所数',
    unit: '所',
  },
  dai1wariai: {
    column: "column03",
    statName: '第1次産業事業所割合',
    unit: '％',
  },
  dai2suu: {
    column: "column04",
    statName: '第2次産業事業所数',
    unit: '所',
  },
  dai2wariai: {
    column: "column05",
    statName: '第2次産業事業所割合',
    unit: '％',
  },
  kougyou: {
    column: "column06",
    statName: '鉱業・採石業・砂利採取業',
    unit: '所',
  },
  kensetugyou: {
    column: "column07",
    statName: '建設業',
    unit: '所',
  },
  seizougyou: {
    column: "column08",
    statName: '製造業',
    unit: '所',
  },
  dai3suu: {
    column: "column09",
    statName: '第3次産業事業所数',
    unit: '所',
  },
  dai3wariai: {
    column: "column10",
    statName: '第3次産業事業所割合',
    unit: '％',
  },
  denki: {
    column: "column11",
    statName: '電気・ガス・熱供給・水道業',
    unit: '所',
  },
  jouhou: {
    column: "column12",
    statName: '情報通信業',
    unit: '所',
  },
  unyu: {
    column: "column13",
    statName: '運輸業・郵便業',
    unit: '所',
  },
  oroshi: {
    column: "column14",
    statName: '卸売業・小売業',
    unit: '所',
  },
  kinyuu: {
    column: "column15",
    statName: '金融業・保険業',
    unit: '所',
  },
  hudousan: {
    column: "column16",
    statName: '不動産業・物品賃貸業',
    unit: '所',
  },
  gakuzyutu: {
    column: "column17",
    statName: '学術研究・専門技術サービス業',
    unit: '所',
  },
  syukuhaku: {
    column: "column18",
    statName: '宿泊業・飲食サービス業',
    unit: '所',
  },
  seikatu: {
    column: "column19",
    statName: '生活関連サービス業・娯楽',
    unit: '所',
  },
  kyouiku: {
    column: "column20",
    statName: '教育・学習支援業',
    unit: '所',
  },
  iryou: {
    column: "column21",
    statName: '医療・福祉',
    unit: '所',
  },
  hukugou: {
    column: "column22",
    statName: '複合サービス事業',
    unit: '所',
  },
  service: {
    column: "column23",
    statName: 'サービス業(他に分類されないもの)',
    unit: '所',
  },
  data:
    [
      {
        "citycode": 45201,
        "cityname": "宮崎市",
        "column01": 18667,
        "column02": 150,
        "column03": 0.803557079,
        "column04": 2349,
        "column05": 12.58370386,
        "column06": 4,
        "column07": 1592,
        "column08": 753,
        "column09": 16168,
        "column10": 86.61273906,
        "column11": 15,
        "column12": 190,
        "column13": 326,
        "column14": 4907,
        "column15": 395,
        "column16": 928,
        "column17": 876,
        "column18": 2971,
        "column19": 1779,
        "column20": 661,
        "column21": 1772,
        "column22": 99,
        "column23": 1249
      },
      {
        "citycode": 45202,
        "cityname": "都城市",
        "column01": 8126,
        "column02": 176,
        "column03": 2.165887275,
        "column04": 1379,
        "column05": 16.97021905,
        "column06": 2,
        "column07": 812,
        "column08": 565,
        "column09": 6571,
        "column10": 80.86389367,
        "column11": 4,
        "column12": 36,
        "column13": 147,
        "column14": 2260,
        "column15": 137,
        "column16": 241,
        "column17": 286,
        "column18": 1120,
        "column19": 888,
        "column20": 246,
        "column21": 650,
        "column22": 69,
        "column23": 487
      },
      {
        "citycode": 45203,
        "cityname": "延岡市",
        "column01": 6499,
        "column02": 92,
        "column03": 1.4156024,
        "column04": 1165,
        "column05": 17.92583474,
        "column06": 0,
        "column07": 745,
        "column08": 420,
        "column09": 5242,
        "column10": 80.65856286,
        "column11": 5,
        "column12": 45,
        "column13": 85,
        "column14": 1667,
        "column15": 101,
        "column16": 263,
        "column17": 201,
        "column18": 952,
        "column19": 720,
        "column20": 216,
        "column21": 542,
        "column22": 67,
        "column23": 378
      },
      {
        "citycode": 45204,
        "cityname": "日南市",
        "column01": 2776,
        "column02": 81,
        "column03": 2.917867435,
        "column04": 444,
        "column05": 15.99423631,
        "column06": 0,
        "column07": 236,
        "column08": 208,
        "column09": 2251,
        "column10": 81.08789625,
        "column11": 3,
        "column12": 9,
        "column13": 50,
        "column14": 715,
        "column15": 50,
        "column16": 85,
        "column17": 82,
        "column18": 419,
        "column19": 290,
        "column20": 68,
        "column21": 238,
        "column22": 37,
        "column23": 205
      },
      {
        "citycode": 45205,
        "cityname": "小林市",
        "column01": 2363,
        "column02": 81,
        "column03": 3.427845959,
        "column04": 406,
        "column05": 17.18154888,
        "column06": 0,
        "column07": 262,
        "column08": 144,
        "column09": 1876,
        "column10": 79.39060516,
        "column11": 0,
        "column12": 4,
        "column13": 31,
        "column14": 642,
        "column15": 40,
        "column16": 61,
        "column17": 79,
        "column18": 310,
        "column19": 257,
        "column20": 55,
        "column21": 214,
        "column22": 21,
        "column23": 162
      },
      {
        "citycode": 45206,
        "cityname": "日向市",
        "column01": 3577,
        "column02": 62,
        "column03": 1.733296058,
        "column04": 616,
        "column05": 17.22113503,
        "column06": 2,
        "column07": 396,
        "column08": 218,
        "column09": 2899,
        "column10": 81.04556891,
        "column11": 3,
        "column12": 16,
        "column13": 78,
        "column14": 955,
        "column15": 51,
        "column16": 162,
        "column17": 101,
        "column18": 553,
        "column19": 377,
        "column20": 96,
        "column21": 273,
        "column22": 26,
        "column23": 208
      },
      {
        "citycode": 45207,
        "cityname": "串間市",
        "column01": 880,
        "column02": 23,
        "column03": 2.613636364,
        "column04": 167,
        "column05": 18.97727273,
        "column06": 1,
        "column07": 97,
        "column08": 69,
        "column09": 690,
        "column10": 78.40909091,
        "column11": 1,
        "column12": 3,
        "column13": 8,
        "column14": 223,
        "column15": 11,
        "column16": 15,
        "column17": 31,
        "column18": 101,
        "column19": 104,
        "column20": 20,
        "column21": 70,
        "column22": 18,
        "column23": 85
      },
      {
        "citycode": 45208,
        "cityname": "西都市",
        "column01": 1459,
        "column02": 41,
        "column03": 2.810143934,
        "column04": 263,
        "column05": 18.02604524,
        "column06": 1,
        "column07": 185,
        "column08": 77,
        "column09": 1155,
        "column10": 79.16381083,
        "column11": 3,
        "column12": 1,
        "column13": 23,
        "column14": 384,
        "column15": 15,
        "column16": 30,
        "column17": 37,
        "column18": 204,
        "column19": 149,
        "column20": 38,
        "column21": 128,
        "column22": 23,
        "column23": 120
      },
      {
        "citycode": 45209,
        "cityname": "えびの市",
        "column01": 1044,
        "column02": 58,
        "column03": 5.555555556,
        "column04": 208,
        "column05": 19.92337165,
        "column06": 0,
        "column07": 145,
        "column08": 63,
        "column09": 778,
        "column10": 74.5210728,
        "column11": 1,
        "column12": 2,
        "column13": 17,
        "column14": 263,
        "column15": 8,
        "column16": 20,
        "column17": 33,
        "column18": 109,
        "column19": 127,
        "column20": 23,
        "column21": 83,
        "column22": 17,
        "column23": 75
      },
      {
        "citycode": 45341,
        "cityname": "三股町",
        "column01": 870,
        "column02": 19,
        "column03": 2.183908046,
        "column04": 222,
        "column05": 25.51724138,
        "column06": 0,
        "column07": 129,
        "column08": 93,
        "column09": 629,
        "column10": 72.29885057,
        "column11": 0,
        "column12": 0,
        "column13": 29,
        "column14": 210,
        "column15": 10,
        "column16": 20,
        "column17": 27,
        "column18": 53,
        "column19": 86,
        "column20": 37,
        "column21": 90,
        "column22": 6,
        "column23": 61
      },
      {
        "citycode": 45361,
        "cityname": "高原町",
        "column01": 380,
        "column02": 18,
        "column03": 4.736842105,
        "column04": 101,
        "column05": 26.57894737,
        "column06": 1,
        "column07": 47,
        "column08": 53,
        "column09": 261,
        "column10": 68.68421053,
        "column11": 0,
        "column12": 1,
        "column13": 7,
        "column14": 97,
        "column15": 3,
        "column16": 6,
        "column17": 10,
        "column18": 29,
        "column19": 38,
        "column20": 6,
        "column21": 25,
        "column22": 8,
        "column23": 31
      },
      {
        "citycode": 45382,
        "cityname": "国富町",
        "column01": 778,
        "column02": 24,
        "column03": 3.084832905,
        "column04": 185,
        "column05": 23.77892031,
        "column06": 1,
        "column07": 114,
        "column08": 70,
        "column09": 569,
        "column10": 73.13624679,
        "column11": 1,
        "column12": 2,
        "column13": 15,
        "column14": 205,
        "column15": 9,
        "column16": 7,
        "column17": 13,
        "column18": 76,
        "column19": 69,
        "column20": 15,
        "column21": 87,
        "column22": 14,
        "column23": 56
      },
      {
        "citycode": 45383,
        "cityname": "綾町",
        "column01": 359,
        "column02": 26,
        "column03": 7.242339833,
        "column04": 83,
        "column05": 23.11977716,
        "column06": 1,
        "column07": 41,
        "column08": 41,
        "column09": 250,
        "column10": 69.63788301,
        "column11": 0,
        "column12": 0,
        "column13": 5,
        "column14": 93,
        "column15": 1,
        "column16": 8,
        "column17": 7,
        "column18": 53,
        "column19": 37,
        "column20": 9,
        "column21": 22,
        "column22": 4,
        "column23": 11
      },
      {
        "citycode": 45401,
        "cityname": "高鍋町",
        "column01": 1173,
        "column02": 20,
        "column03": 1.705029838,
        "column04": 115,
        "column05": 9.803921569,
        "column06": 0,
        "column07": 79,
        "column08": 36,
        "column09": 1038,
        "column10": 88.49104859,
        "column11": 1,
        "column12": 2,
        "column13": 19,
        "column14": 330,
        "column15": 17,
        "column16": 55,
        "column17": 41,
        "column18": 215,
        "column19": 120,
        "column20": 43,
        "column21": 100,
        "column22": 9,
        "column23": 86
      },
      {
        "citycode": 45402,
        "cityname": "新富町",
        "column01": 661,
        "column02": 31,
        "column03": 4.689863843,
        "column04": 159,
        "column05": 24.05446293,
        "column06": 2,
        "column07": 90,
        "column08": 67,
        "column09": 471,
        "column10": 71.25567322,
        "column11": 0,
        "column12": 4,
        "column13": 10,
        "column14": 172,
        "column15": 8,
        "column16": 11,
        "column17": 19,
        "column18": 68,
        "column19": 65,
        "column20": 11,
        "column21": 54,
        "column22": 6,
        "column23": 43
      },
      {
        "citycode": 45403,
        "cityname": "西米良村",
        "column01": 93,
        "column02": 5,
        "column03": 5.376344086,
        "column04": 17,
        "column05": 18.27956989,
        "column06": 0,
        "column07": 14,
        "column08": 3,
        "column09": 71,
        "column10": 76.34408602,
        "column11": 0,
        "column12": 0,
        "column13": 1,
        "column14": 25,
        "column15": 0,
        "column16": 1,
        "column17": 0,
        "column18": 17,
        "column19": 12,
        "column20": 2,
        "column21": 3,
        "column22": 3,
        "column23": 7
      },
      {
        "citycode": 45404,
        "cityname": "木城町",
        "column01": 207,
        "column02": 8,
        "column03": 3.8647343,
        "column04": 54,
        "column05": 26.08695652,
        "column06": 0,
        "column07": 28,
        "column08": 26,
        "column09": 145,
        "column10": 70.04830918,
        "column11": 0,
        "column12": 1,
        "column13": 2,
        "column14": 51,
        "column15": 5,
        "column16": 2,
        "column17": 3,
        "column18": 20,
        "column19": 9,
        "column20": 6,
        "column21": 25,
        "column22": 3,
        "column23": 18
      },
      {
        "citycode": 45405,
        "cityname": "川南町",
        "column01": 627,
        "column02": 74,
        "column03": 11.80223285,
        "column04": 117,
        "column05": 18.66028708,
        "column06": 0,
        "column07": 59,
        "column08": 58,
        "column09": 436,
        "column10": 69.53748006,
        "column11": 2,
        "column12": 1,
        "column13": 22,
        "column14": 135,
        "column15": 4,
        "column16": 15,
        "column17": 18,
        "column18": 60,
        "column19": 62,
        "column20": 14,
        "column21": 45,
        "column22": 6,
        "column23": 52
      },
      {
        "citycode": 45406,
        "cityname": "都農町",
        "column01": 388,
        "column02": 19,
        "column03": 4.896907216,
        "column04": 75,
        "column05": 19.32989691,
        "column06": 1,
        "column07": 46,
        "column08": 28,
        "column09": 294,
        "column10": 75.77319588,
        "column11": 1,
        "column12": 2,
        "column13": 10,
        "column14": 92,
        "column15": 4,
        "column16": 3,
        "column17": 12,
        "column18": 54,
        "column19": 40,
        "column20": 8,
        "column21": 31,
        "column22": 3,
        "column23": 34
      },
      {
        "citycode": 45421,
        "cityname": "門川町",
        "column01": 742,
        "column02": 10,
        "column03": 1.347708895,
        "column04": 171,
        "column05": 23.0458221,
        "column06": 0,
        "column07": 90,
        "column08": 81,
        "column09": 561,
        "column10": 75.606469,
        "column11": 0,
        "column12": 2,
        "column13": 13,
        "column14": 210,
        "column15": 7,
        "column16": 16,
        "column17": 17,
        "column18": 55,
        "column19": 85,
        "column20": 22,
        "column21": 70,
        "column22": 9,
        "column23": 55
      },
      {
        "citycode": 45429,
        "cityname": "諸塚村",
        "column01": 84,
        "column02": 6,
        "column03": 7.142857143,
        "column04": 22,
        "column05": 26.19047619,
        "column06": 0,
        "column07": 12,
        "column08": 10,
        "column09": 56,
        "column10": 66.66666667,
        "column11": 1,
        "column12": 0,
        "column13": 2,
        "column14": 20,
        "column15": 0,
        "column16": 0,
        "column17": 0,
        "column18": 8,
        "column19": 9,
        "column20": 0,
        "column21": 4,
        "column22": 3,
        "column23": 9
      },
      {
        "citycode": 45430,
        "cityname": "椎葉村",
        "column01": 153,
        "column02": 5,
        "column03": 3.267973856,
        "column04": 36,
        "column05": 23.52941176,
        "column06": 0,
        "column07": 29,
        "column08": 7,
        "column09": 112,
        "column10": 73.20261438,
        "column11": 0,
        "column12": 0,
        "column13": 5,
        "column14": 40,
        "column15": 2,
        "column16": 1,
        "column17": 5,
        "column18": 26,
        "column19": 10,
        "column20": 1,
        "column21": 5,
        "column22": 5,
        "column23": 12
      },
      {
        "citycode": 45431,
        "cityname": "美郷町",
        "column01": 269,
        "column02": 18,
        "column03": 6.691449814,
        "column04": 69,
        "column05": 25.65055762,
        "column06": 0,
        "column07": 41,
        "column08": 28,
        "column09": 182,
        "column10": 67.65799257,
        "column11": 0,
        "column12": 0,
        "column13": 3,
        "column14": 75,
        "column15": 0,
        "column16": 3,
        "column17": 3,
        "column18": 30,
        "column19": 16,
        "column20": 2,
        "column21": 18,
        "column22": 8,
        "column23": 24
      },
      {
        "citycode": 45441,
        "cityname": "高千穂町",
        "column01": 748,
        "column02": 20,
        "column03": 2.673796791,
        "column04": 130,
        "column05": 17.37967914,
        "column06": 0,
        "column07": 93,
        "column08": 37,
        "column09": 598,
        "column10": 79.94652406,
        "column11": 1,
        "column12": 4,
        "column13": 15,
        "column14": 226,
        "column15": 6,
        "column16": 26,
        "column17": 24,
        "column18": 108,
        "column19": 68,
        "column20": 10,
        "column21": 43,
        "column22": 9,
        "column23": 58
      },
      {
        "citycode": 45442,
        "cityname": "日之影町",
        "column01": 198,
        "column02": 11,
        "column03": 5.555555556,
        "column04": 48,
        "column05": 24.24242424,
        "column06": 0,
        "column07": 29,
        "column08": 19,
        "column09": 139,
        "column10": 70.2020202,
        "column11": 2,
        "column12": 0,
        "column13": 4,
        "column14": 56,
        "column15": 1,
        "column16": 1,
        "column17": 3,
        "column18": 28,
        "column19": 18,
        "column20": 2,
        "column21": 12,
        "column22": 5,
        "column23": 7
      },
      {
        "citycode": 45443,
        "cityname": "五ヶ瀬町",
        "column01": 148,
        "column02": 7,
        "column03": 4.72972973,
        "column04": 37,
        "column05": 25,
        "column06": 0,
        "column07": 25,
        "column08": 12,
        "column09": 104,
        "column10": 70.27027027,
        "column11": 0,
        "column12": 0,
        "column13": 2,
        "column14": 40,
        "column15": 1,
        "column16": 0,
        "column17": 1,
        "column18": 18,
        "column19": 16,
        "column20": 0,
        "column21": 7,
        "column22": 4,
        "column23": 15
      }
    ]
};

export const roudouryoku = {
  sousuu: {
    column: "column01",
    statName: '総数(15歳以上人口)',
    unit: '人',
  },
  jinkou: {
    column: "column02",
    statName: '労働力人口',
    unit: '人',
  },
  roudouryokuritu: {
    column: "column03",
    statName: '労働力率',
    unit: '％',
  },
  syuugyousya: {
    column: "column04",
    statName: '就業者',
    unit: '人',
  },
  syuugyousyawariai: {
    column: "column05",
    statName: '就業者割合',
    unit: '％',
  },
  shitugyousya: {
    column: "column06",
    statName: '完全失業者',
    unit: '人',
  },
  shitugyousyawariai: {
    column: "column07",
    statName: '完全失業者割合',
    unit: '％',
  },
  shitugyouritu: {
    column: "column08",
    statName: '完全失業率',
    unit: '％',
  },
  hiroudoujinkou: {
    column: "column09",
    statName: '非労働力人口',
    unit: '人',
  },
  hiroudouryokuritu: {
    column: "column10",
    statName: '非労働力率',
    unit: '％',
  },
  kajiwariai: {
    column: "column11",
    statName: '家事割合',
    unit: '％',
  },
  jishichyouson: {
    column: "column12",
    statName: '自市町村内通勤者数',
    unit: '人',
  },
  ikinaihiritu: {
    column: "column13",
    statName: '域内通勤者比率',
    unit: '％',
  },
  fromhokahichyouson: {
    column: "column14",
    statName: '他市町村からの通勤者',
    unit: '人',
  },
  fromhokahichyousonritu: {
    column: "column15",
    statName: '他市町村からの通勤者比率',
    unit: '％',
  },
  tohokahichyouson: {
    column: "column16",
    statName: '他市町村への通勤者',
    unit: '人',
  },
  tohokahichyousonritu: {
    column: "column17",
    statName: '他市町村への通勤者比率',
    unit: '％',
  },
  data:
    [
      {
        "citycode": 45201,
        "cityname": "宮崎市",
        "column01": 338548,
        "column02": 196292,
        "column03": 60.21097706,
        "column04": 187229,
        "column05": 57.43097541,
        "column06": 9063,
        "column07": 2.780001656,
        "column08": 4.617101054,
        "column09": 129715,
        "column10": 39.78902294,
        "column11": 13.29173913,
        "column12": 150227,
        "column13": 80.23703593,
        "column14": 15708,
        "column15": 8.282145512,
        "column16": 13599,
        "column17": 7.263297887
      },
      {
        "citycode": 45202,
        "cityname": "都城市",
        "column01": 141121,
        "column02": 80883,
        "column03": 58.68699255,
        "column04": 77032,
        "column05": 55.89278847,
        "column06": 3851,
        "column07": 2.794204076,
        "column08": 4.761198274,
        "column09": 56938,
        "column10": 41.31300745,
        "column11": 12.37692369,
        "column12": 57706,
        "column13": 74.911725,
        "column14": 14433,
        "column15": 17.31800674,
        "column16": 8183,
        "column17": 10.62285803
      },
      {
        "citycode": 45203,
        "cityname": "延岡市",
        "column01": 108280,
        "column02": 59155,
        "column03": 55.85666399,
        "column04": 55997,
        "column05": 52.87474623,
        "column06": 3158,
        "column07": 2.981917756,
        "column08": 5.338517454,
        "column09": 46750,
        "column10": 44.14333601,
        "column11": 13.93985175,
        "column12": 45299,
        "column13": 80.89540511,
        "column14": 5185,
        "column15": 9.058350804,
        "column16": 4056,
        "column17": 7.243245174
      },
      {
        "citycode": 45204,
        "cityname": "日南市",
        "column01": 47650,
        "column02": 25392,
        "column03": 54.11418707,
        "column04": 23958,
        "column05": 51.05811649,
        "column06": 1434,
        "column07": 3.056070584,
        "column08": 5.647448015,
        "column09": 21531,
        "column10": 45.88581293,
        "column11": 12.75707009,
        "column12": 18451,
        "column13": 77.01394106,
        "column14": 1903,
        "column15": 8.03021352,
        "column16": 2180,
        "column17": 9.099257033
      },
      {
        "citycode": 45205,
        "cityname": "小林市",
        "column01": 40126,
        "column02": 23526,
        "column03": 59.58966565,
        "column04": 22741,
        "column05": 57.60131712,
        "column06": 785,
        "column07": 1.988348531,
        "column08": 3.336733826,
        "column09": 15954,
        "column10": 40.41033435,
        "column11": 11.70466059,
        "column12": 13586,
        "column13": 59.74231564,
        "column14": 3925,
        "column15": 17.07784014,
        "column16": 3714,
        "column17": 16.33173563
      },
      {
        "citycode": 45206,
        "cityname": "日向市",
        "column01": 52841,
        "column02": 30944,
        "column03": 59.49396293,
        "column04": 29446,
        "column05": 56.61385834,
        "column06": 1498,
        "column07": 2.880104591,
        "column08": 4.841003102,
        "column09": 21068,
        "column10": 40.50603707,
        "column11": 12.47788972,
        "column12": 20732,
        "column13": 70.40684643,
        "column14": 5564,
        "column15": 18.50287653,
        "column16": 4978,
        "column17": 16.90552197
      },
      {
        "citycode": 45207,
        "cityname": "串間市",
        "column01": 16398,
        "column02": 9125,
        "column03": 55.73540191,
        "column04": 8789,
        "column05": 53.68311752,
        "column06": 336,
        "column07": 2.052284388,
        "column08": 3.682191781,
        "column09": 7247,
        "column10": 44.26459809,
        "column11": 10.94551674,
        "column12": 5027,
        "column13": 57.19649562,
        "column14": 903,
        "column15": 10.88214027,
        "column16": 1398,
        "column17": 15.90624644
      },
      {
        "citycode": 45208,
        "cityname": "西都市",
        "column01": 26813,
        "column02": 15650,
        "column03": 59.81729924,
        "column04": 14928,
        "column05": 57.05767687,
        "column06": 722,
        "column07": 2.759622367,
        "column08": 4.61341853,
        "column09": 10513,
        "column10": 40.18270076,
        "column11": 10.54924894,
        "column12": 6225,
        "column13": 41.70016077,
        "column14": 3729,
        "column15": 26.23839009,
        "column16": 4470,
        "column17": 29.9437299
      },
      {
        "citycode": 45209,
        "cityname": "えびの市",
        "column01": 17006,
        "column02": 9645,
        "column03": 57.05075121,
        "column04": 9291,
        "column05": 54.95682006,
        "column06": 354,
        "column07": 2.093931149,
        "column08": 3.67029549,
        "column09": 7261,
        "column10": 42.94924879,
        "column11": 12.84750976,
        "column12": 5100,
        "column13": 54.8918308,
        "column14": 2125,
        "column15": 21.78593398,
        "column16": 1679,
        "column17": 18.07125175
      },
      {
        "citycode": 45341,
        "cityname": "三股町",
        "column01": 20904,
        "column02": 12435,
        "column03": 59.97395582,
        "column04": 11927,
        "column05": 57.52387383,
        "column06": 508,
        "column07": 2.450081991,
        "column08": 4.085243265,
        "column09": 8299,
        "column10": 40.02604418,
        "column11": 13.0462043,
        "column12": 3524,
        "column13": 29.54640731,
        "column14": 2572,
        "column15": 34.70516799,
        "column16": 7103,
        "column17": 59.55395322
      },
      {
        "citycode": 45361,
        "cityname": "高原町",
        "column01": 8303,
        "column02": 4857,
        "column03": 58.75877087,
        "column04": 4653,
        "column05": 56.29082991,
        "column06": 204,
        "column07": 2.467940963,
        "column08": 4.200123533,
        "column09": 3409,
        "column10": 41.24122913,
        "column11": 11.86789257,
        "column12": 1319,
        "column13": 28.34730282,
        "column14": 1024,
        "column15": 28.65137101,
        "column16": 2107,
        "column17": 45.28261337
      },
      {
        "citycode": 45382,
        "cityname": "国富町",
        "column01": 17339,
        "column02": 10211,
        "column03": 60.00822755,
        "column04": 9836,
        "column05": 57.80441937,
        "column06": 375,
        "column07": 2.203808181,
        "column08": 3.672510038,
        "column09": 6805,
        "column10": 39.99177245,
        "column11": 10.47249647,
        "column12": 3687,
        "column13": 37.4847499,
        "column14": 3308,
        "column15": 35.56989247,
        "column16": 3876,
        "column17": 39.40626271
      },
      {
        "citycode": 45383,
        "cityname": "綾町",
        "column01": 6255,
        "column02": 3842,
        "column03": 61.43268308,
        "column04": 3687,
        "column05": 58.95426927,
        "column06": 155,
        "column07": 2.478413815,
        "column08": 4.034357106,
        "column09": 2412,
        "column10": 38.56731692,
        "column11": 11.30476495,
        "column12": 1434,
        "column13": 38.89340928,
        "column14": 930,
        "column15": 29.08977166,
        "column16": 1421,
        "column17": 38.54081909
      },
      {
        "citycode": 45401,
        "cityname": "高鍋町",
        "column01": 18096,
        "column02": 10380,
        "column03": 58.85688365,
        "column04": 9849,
        "column05": 55.84599682,
        "column06": 531,
        "column07": 3.010886822,
        "column08": 5.115606936,
        "column09": 7256,
        "column10": 41.14311635,
        "column11": 12.55386709,
        "column12": 4097,
        "column13": 41.59813179,
        "column14": 3616,
        "column15": 39.44153578,
        "column16": 4310,
        "column17": 43.7607879
      },
      {
        "citycode": 45402,
        "cityname": "新富町",
        "column01": 14837,
        "column02": 9495,
        "column03": 64.10775775,
        "column04": 9095,
        "column05": 61.40706232,
        "column06": 400,
        "column07": 2.700695429,
        "column08": 4.212743549,
        "column09": 5316,
        "column10": 35.89224225,
        "column11": 10.93106475,
        "column12": 3430,
        "column13": 37.71302914,
        "column14": 3106,
        "column15": 37.48491431,
        "column16": 3919,
        "column17": 43.08960968
      },
      {
        "citycode": 45403,
        "cityname": "西米良村",
        "column01": 937,
        "column02": 555,
        "column03": 59.23159018,
        "column04": 550,
        "column05": 58.69797225,
        "column06": 5,
        "column07": 0.53361793,
        "column08": 0.900900901,
        "column09": 382,
        "column10": 40.76840982,
        "column11": 13.55389541,
        "column12": 400,
        "column13": 72.72727273,
        "column14": 111,
        "column15": 17.37089202,
        "column16": 22,
        "column17": 4
      },
      {
        "citycode": 45404,
        "cityname": "木城町",
        "column01": 4458,
        "column02": 2672,
        "column03": 59.95063944,
        "column04": 2557,
        "column05": 57.37042854,
        "column06": 115,
        "column07": 2.580210904,
        "column08": 4.303892216,
        "column09": 1785,
        "column10": 40.04936056,
        "column11": 9.58043527,
        "column12": 793,
        "column13": 31.01290575,
        "column14": 1403,
        "column15": 51.39194139,
        "column16": 1231,
        "column17": 48.14235432
      },
      {
        "citycode": 45405,
        "cityname": "川南町",
        "column01": 13872,
        "column02": 8637,
        "column03": 62.46926081,
        "column04": 8271,
        "column05": 59.82207435,
        "column06": 366,
        "column07": 2.64718646,
        "column08": 4.237582494,
        "column09": 5189,
        "column10": 37.53073919,
        "column11": 9.445971358,
        "column12": 3458,
        "column13": 41.8087293,
        "column14": 2650,
        "column15": 31.65312948,
        "column16": 2554,
        "column17": 30.87897473
      },
      {
        "citycode": 45406,
        "cityname": "都農町",
        "column01": 9052,
        "column02": 5368,
        "column03": 59.59809037,
        "column04": 5074,
        "column05": 56.33396247,
        "column06": 294,
        "column07": 3.264127901,
        "column08": 5.476900149,
        "column09": 3639,
        "column10": 40.40190963,
        "column11": 12.05728878,
        "column12": 1751,
        "column13": 34.50926291,
        "column14": 1186,
        "column15": 27.22681359,
        "column16": 1910,
        "column17": 37.6428853
      },
      {
        "citycode": 45421,
        "cityname": "門川町",
        "column01": 15590,
        "column02": 9091,
        "column03": 58.3616871,
        "column04": 8602,
        "column05": 55.22244335,
        "column06": 489,
        "column07": 3.139243757,
        "column08": 5.378946211,
        "column09": 6486,
        "column10": 41.6383129,
        "column11": 14.69474225,
        "column12": 3320,
        "column13": 38.59567542,
        "column14": 2518,
        "column15": 36.77523003,
        "column16": 4281,
        "column17": 49.76749593
      },
      {
        "citycode": 45429,
        "cityname": "諸塚村",
        "column01": 1523,
        "column02": 987,
        "column03": 64.80630335,
        "column04": 970,
        "column05": 63.69008536,
        "column06": 17,
        "column07": 1.116217991,
        "column08": 1.722391084,
        "column09": 536,
        "column10": 35.19369665,
        "column11": 11.49047932,
        "column12": 605,
        "column13": 62.37113402,
        "column14": 112,
        "column15": 11.03448276,
        "column16": 70,
        "column17": 7.216494845
      },
      {
        "citycode": 45430,
        "cityname": "椎葉村",
        "column01": 2467,
        "column02": 1463,
        "column03": 59.30279692,
        "column04": 1441,
        "column05": 58.41102554,
        "column06": 22,
        "column07": 0.891771382,
        "column08": 1.503759398,
        "column09": 1004,
        "column10": 40.69720308,
        "column11": 15.07904337,
        "column12": 923,
        "column13": 64.05274115,
        "column14": 101,
        "column15": 6.760374833,
        "column16": 48,
        "column17": 3.331020125
      },
      {
        "citycode": 45431,
        "cityname": "美郷町",
        "column01": 4989,
        "column02": 2694,
        "column03": 53.99879735,
        "column04": 2614,
        "column05": 52.39526959,
        "column06": 80,
        "column07": 1.603527761,
        "column08": 2.96956199,
        "column09": 2295,
        "column10": 46.00120265,
        "column11": 13.28923632,
        "column12": 1400,
        "column13": 53.55776588,
        "column14": 436,
        "column15": 16.63487219,
        "column16": 431,
        "column17": 16.48814078
      },
      {
        "citycode": 45441,
        "cityname": "高千穂町",
        "column01": 11235,
        "column02": 6699,
        "column03": 59.63147588,
        "column04": 6531,
        "column05": 58.13601567,
        "column06": 168,
        "column07": 1.49546021,
        "column08": 2.507836991,
        "column09": 4535,
        "column10": 40.36852412,
        "column11": 11.31386861,
        "column12": 3897,
        "column13": 59.66926964,
        "column14": 737,
        "column15": 11.14808652,
        "column16": 658,
        "column17": 10.0750268
      },
      {
        "citycode": 45442,
        "cityname": "日之影町",
        "column01": 3536,
        "column02": 2217,
        "column03": 62.6979638,
        "column04": 2160,
        "column05": 61.08597285,
        "column06": 57,
        "column07": 1.61199095,
        "column08": 2.571041949,
        "column09": 1319,
        "column10": 37.3020362,
        "column11": 9.587104072,
        "column12": 882,
        "column13": 40.83333333,
        "column14": 389,
        "column15": 18.99414063,
        "column16": 502,
        "column17": 23.24074074
      },
      {
        "citycode": 45443,
        "cityname": "五ヶ瀬町",
        "column01": 3343,
        "column02": 2021,
        "column03": 60.45468142,
        "column04": 1982,
        "column05": 59.28806461,
        "column06": 39,
        "column07": 1.166616811,
        "column08": 1.929737754,
        "column09": 1322,
        "column10": 39.54531858,
        "column11": 10.02093928,
        "column12": 808,
        "column13": 40.76690212,
        "column14": 193,
        "column15": 11.28654971,
        "column16": 466,
        "column17": 23.51160444
      }
    ]
};

export const sangyoubetu = {
  dai1: {
    column: "column01",
    statName: '第1次産業',
    unit: '人',
  },
  dai1wariai: {
    column: "column02",
    statName: '第1次産業就業者割合',
    unit: '％',
  },
  nouringyou: {
    column: "column03",
    statName: '農業・林業',
    unit: '人',
  },
  nougyou: {
    column: "column04",
    statName: '農業・林業うち農業',
    unit: '人',
  },
  gyogyou: {
    column: "column05",
    statName: '漁業',
    unit: '人',
  },
  dai2: {
    column: "column06",
    statName: '第2次産業',
    unit: '人',
  },
  dai2wariai: {
    column: "column07",
    statName: '第2次産業就業者割合',
    unit: '％',
  },
  kougyousaiseki: {
    column: "column08",
    statName: '鉱業・採石・砂利採取業',
    unit: '人',
  },
  kensetu: {
    column: "column09",
    statName: '建設業',
    unit: '人',
  },
  seizou: {
    column: "column10",
    statName: '製造業',
    unit: '人',
  },
  dai3: {
    column: "column11",
    statName: '第3次産業',
    unit: '人',
  },
  dai3wariai: {
    column: "column12",
    statName: '第3次産業就業者割合',
    unit: '％',
  },
  denki: {
    column: "column13",
    statName: '電気・ガス・熱供給・水道業',
    unit: '人',
  },
  jouhou: {
    column: "column14",
    statName: '情報通信業',
    unit: '人',
  },
  unyu: {
    column: "column15",
    statName: '運輸業・郵送業',
    unit: '人',
  },
  oroshi: {
    column: "column16",
    statName: '卸売業・小売業',
    unit: '人',
  },
  kinyuu: {
    column: "column17",
    statName: '金融業・保険業',
    unit: '人',
  },
  hudousan: {
    column: "column18",
    statName: '不動産業・物品賃貸業',
    unit: '人',
  },
  gakuzyutu: {
    column: "column19",
    statName: '学術研究・専門・技術サービス業',
    unit: '人',
  },
  syukuhaku: {
    column: "column20",
    statName: '宿泊業・飲食サービス業',
    unit: '人',
  },
  seikatu: {
    column: "column21",
    statName: '生活関連サービス業・娯楽',
    unit: '人',
  },
  kyouiku: {
    column: "column22",
    statName: '教育・学習支援業',
    unit: '人',
  },
  iryou: {
    column: "column23",
    statName: '医療・福祉',
    unit: '人',
  },
  hukugou: {
    column: "column24",
    statName: '複合サービス業',
    unit: '人',
  },
  service: {
    column: "column25",
    statName: 'サービス業(他に分類されないもの)',
    unit: '人',
  },
  koumu: {
    column: "column26",
    statName: '公務(他に分類されるものを除く)',
    unit: '人',
  },
  hunou: {
    column: "column27",
    statName: '分類不能の産業',
    unit: '人',
  },
  data:
    [
      {
        "citycode": 45201,
        "cityname": "宮崎市",
        "column01": 9661,
        "column02": 5.159991241,
        "column03": 9276,
        "column04": 8938,
        "column05": 385,
        "column06": 28871,
        "column07": 15.42015393,
        "column08": 26,
        "column09": 13661,
        "column10": 15184,
        "column11": 138209,
        "column12": 73.81815851,
        "column13": 1126,
        "column14": 4081,
        "column15": 7403,
        "column16": 31391,
        "column17": 5566,
        "column18": 3498,
        "column19": 5984,
        "column20": 12226,
        "column21": 7260,
        "column22": 11395,
        "column23": 29706,
        "column24": 1417,
        "column25": 11593,
        "column26": 8730,
        "column27": 7321
      },
      {
        "citycode": 45202,
        "cityname": "都城市",
        "column01": 7366,
        "column02": 9.56225984,
        "column03": 7351,
        "column04": 7086,
        "column05": 15,
        "column06": 18753,
        "column07": 24.34442829,
        "column08": 35,
        "column09": 6796,
        "column10": 11922,
        "column11": 49575,
        "column12": 64.35637138,
        "column13": 264,
        "column14": 584,
        "column15": 3401,
        "column16": 12321,
        "column17": 1203,
        "column18": 825,
        "column19": 1584,
        "column20": 3537,
        "column21": 2909,
        "column22": 3040,
        "column23": 12284,
        "column24": 1021,
        "column25": 3614,
        "column26": 3271,
        "column27": 1055
      },
      {
        "citycode": 45203,
        "cityname": "延岡市",
        "column01": 3017,
        "column02": 5.387788632,
        "column03": 2231,
        "column04": 1879,
        "column05": 786,
        "column06": 15279,
        "column07": 27.28539029,
        "column08": 3,
        "column09": 6196,
        "column10": 9080,
        "column11": 36203,
        "column12": 64.65167777,
        "column13": 304,
        "column14": 549,
        "column15": 2064,
        "column16": 8727,
        "column17": 917,
        "column18": 746,
        "column19": 1178,
        "column20": 2890,
        "column21": 2180,
        "column22": 2430,
        "column23": 8851,
        "column24": 740,
        "column25": 3182,
        "column26": 1981,
        "column27": 962
      },
      {
        "citycode": 45204,
        "cityname": "日南市",
        "column01": 2912,
        "column02": 12.15460389,
        "column03": 2172,
        "column04": 2020,
        "column05": 740,
        "column06": 5133,
        "column07": 21.42499374,
        "column08": 6,
        "column09": 1600,
        "column10": 3527,
        "column11": 16460,
        "column12": 68.70356457,
        "column13": 113,
        "column14": 86,
        "column15": 1439,
        "column16": 3221,
        "column17": 425,
        "column18": 198,
        "column19": 386,
        "column20": 1286,
        "column21": 834,
        "column22": 1002,
        "column23": 4152,
        "column24": 473,
        "column25": 1130,
        "column26": 992,
        "column27": 176
      },
      {
        "citycode": 45205,
        "cityname": "小林市",
        "column01": 4784,
        "column02": 21.03689372,
        "column03": 4780,
        "column04": 4561,
        "column05": 4,
        "column06": 4320,
        "column07": 18.9965261,
        "column08": 6,
        "column09": 1896,
        "column10": 2418,
        "column11": 13236,
        "column12": 58.20324524,
        "column13": 50,
        "column14": 55,
        "column15": 566,
        "column16": 2865,
        "column17": 279,
        "column18": 168,
        "column19": 392,
        "column20": 1097,
        "column21": 770,
        "column22": 736,
        "column23": 3804,
        "column24": 401,
        "column25": 960,
        "column26": 1097,
        "column27": 397
      },
      {
        "citycode": 45206,
        "cityname": "日向市",
        "column01": 2123,
        "column02": 7.209807784,
        "column03": 1866,
        "column04": 1582,
        "column05": 257,
        "column06": 8642,
        "column07": 29.34863819,
        "column08": 24,
        "column09": 3161,
        "column10": 5457,
        "column11": 18111,
        "column12": 61.50580724,
        "column13": 159,
        "column14": 153,
        "column15": 1243,
        "column16": 4341,
        "column17": 495,
        "column18": 315,
        "column19": 540,
        "column20": 1442,
        "column21": 1060,
        "column22": 1133,
        "column23": 4648,
        "column24": 421,
        "column25": 1383,
        "column26": 966,
        "column27": 382
      },
      {
        "citycode": 45207,
        "cityname": "串間市",
        "column01": 2382,
        "column02": 27.10205939,
        "column03": 2113,
        "column04": 1989,
        "column05": 269,
        "column06": 1351,
        "column07": 15.37148709,
        "column08": 3,
        "column09": 624,
        "column10": 724,
        "column11": 5138,
        "column12": 58.45943793,
        "column13": 23,
        "column14": 15,
        "column15": 268,
        "column16": 971,
        "column17": 103,
        "column18": 32,
        "column19": 147,
        "column20": 333,
        "column21": 248,
        "column22": 248,
        "column23": 1526,
        "column24": 235,
        "column25": 376,
        "column26": 522,
        "column27": 9
      },
      {
        "citycode": 45208,
        "cityname": "西都市",
        "column01": 3732,
        "column02": 25,
        "column03": 3715,
        "column04": 3588,
        "column05": 17,
        "column06": 3097,
        "column07": 20.74624866,
        "column08": 2,
        "column09": 1241,
        "column10": 1854,
        "column11": 8164,
        "column12": 54.68917471,
        "column13": 35,
        "column14": 60,
        "column15": 444,
        "column16": 1816,
        "column17": 189,
        "column18": 108,
        "column19": 185,
        "column20": 594,
        "column21": 510,
        "column22": 404,
        "column23": 1947,
        "column24": 313,
        "column25": 703,
        "column26": 617,
        "column27": 174
      },
      {
        "citycode": 45209,
        "cityname": "えびの市",
        "column01": 2172,
        "column02": 23.37746206,
        "column03": 2168,
        "column04": 2109,
        "column05": 4,
        "column06": 1877,
        "column07": 20.20234636,
        "column08": 5,
        "column09": 738,
        "column10": 1134,
        "column11": 5543,
        "column12": 59.65988591,
        "column13": 14,
        "column14": 13,
        "column15": 311,
        "column16": 984,
        "column17": 75,
        "column18": 53,
        "column19": 117,
        "column20": 446,
        "column21": 310,
        "column22": 274,
        "column23": 1299,
        "column24": 240,
        "column25": 347,
        "column26": 682,
        "column27": 77
      },
      {
        "citycode": 45341,
        "cityname": "三股町",
        "column01": 839,
        "column02": 7.034459629,
        "column03": 832,
        "column04": 778,
        "column05": 7,
        "column06": 3099,
        "column07": 25.98306364,
        "column08": 4,
        "column09": 1099,
        "column10": 1996,
        "column11": 7529,
        "column12": 63.12568123,
        "column13": 33,
        "column14": 74,
        "column15": 627,
        "column16": 1875,
        "column17": 170,
        "column18": 127,
        "column19": 200,
        "column20": 452,
        "column21": 470,
        "column22": 541,
        "column23": 2071,
        "column24": 173,
        "column25": 643,
        "column26": 471,
        "column27": 62
      },
      {
        "citycode": 45361,
        "cityname": "高原町",
        "column01": 1144,
        "column02": 24.58628842,
        "column03": 1141,
        "column04": 1111,
        "column05": 3,
        "column06": 987,
        "column07": 21.21212121,
        "column08": 3,
        "column09": 381,
        "column10": 603,
        "column11": 2514,
        "column12": 54.02965828,
        "column13": 5,
        "column14": 14,
        "column15": 145,
        "column16": 513,
        "column17": 54,
        "column18": 20,
        "column19": 81,
        "column20": 154,
        "column21": 127,
        "column22": 92,
        "column23": 747,
        "column24": 119,
        "column25": 262,
        "column26": 181,
        "column27": 8
      },
      {
        "citycode": 45382,
        "cityname": "国富町",
        "column01": 1970,
        "column02": 20.02846686,
        "column03": 1965,
        "column04": 1922,
        "column05": 5,
        "column06": 2153,
        "column07": 21.88897926,
        "column08": 3,
        "column09": 964,
        "column10": 1186,
        "column11": 5551,
        "column12": 56.4355429,
        "column13": 24,
        "column14": 56,
        "column15": 356,
        "column16": 1367,
        "column17": 122,
        "column18": 78,
        "column19": 159,
        "column20": 328,
        "column21": 317,
        "column22": 233,
        "column23": 1556,
        "column24": 177,
        "column25": 492,
        "column26": 286,
        "column27": 162
      },
      {
        "citycode": 45383,
        "cityname": "綾町",
        "column01": 819,
        "column02": 22.21318145,
        "column03": 812,
        "column04": 783,
        "column05": 7,
        "column06": 868,
        "column07": 23.54217521,
        "column08": 2,
        "column09": 339,
        "column10": 527,
        "column11": 1997,
        "column12": 54.16327638,
        "column13": 10,
        "column14": 28,
        "column15": 138,
        "column16": 386,
        "column17": 30,
        "column18": 30,
        "column19": 51,
        "column20": 218,
        "column21": 109,
        "column22": 104,
        "column23": 500,
        "column24": 90,
        "column25": 176,
        "column26": 127,
        "column27": 3
      },
      {
        "citycode": 45401,
        "cityname": "高鍋町",
        "column01": 1158,
        "column02": 11.75753884,
        "column03": 1136,
        "column04": 1119,
        "column05": 22,
        "column06": 1944,
        "column07": 19.73804447,
        "column08": 1,
        "column09": 592,
        "column10": 1351,
        "column11": 6633,
        "column12": 67.34693878,
        "column13": 76,
        "column14": 72,
        "column15": 376,
        "column16": 1413,
        "column17": 186,
        "column18": 85,
        "column19": 180,
        "column20": 536,
        "column21": 408,
        "column22": 516,
        "column23": 1510,
        "column24": 159,
        "column25": 474,
        "column26": 642,
        "column27": 114
      },
      {
        "citycode": 45402,
        "cityname": "新富町",
        "column01": 1739,
        "column02": 19.12039582,
        "column03": 1663,
        "column04": 1645,
        "column05": 76,
        "column06": 1816,
        "column07": 19.96701484,
        "column08": 4,
        "column09": 626,
        "column10": 1186,
        "column11": 5530,
        "column12": 60.80263881,
        "column13": 33,
        "column14": 67,
        "column15": 316,
        "column16": 1133,
        "column17": 115,
        "column18": 46,
        "column19": 107,
        "column20": 341,
        "column21": 295,
        "column22": 247,
        "column23": 1116,
        "column24": 106,
        "column25": 399,
        "column26": 1209,
        "column27": 10
      },
      {
        "citycode": 45403,
        "cityname": "西米良村",
        "column01": 128,
        "column02": 23.27272727,
        "column03": 125,
        "column04": 86,
        "column05": 3,
        "column06": 86,
        "column07": 15.63636364,
        "column08": 0,
        "column09": 65,
        "column10": 21,
        "column11": 335,
        "column12": 60.90909091,
        "column13": 1,
        "column14": 4,
        "column15": 9,
        "column16": 37,
        "column17": 0,
        "column18": 0,
        "column19": 11,
        "column20": 45,
        "column21": 22,
        "column22": 30,
        "column23": 79,
        "column24": 14,
        "column25": 18,
        "column26": 65,
        "column27": 1
      },
      {
        "citycode": 45404,
        "cityname": "木城町",
        "column01": 538,
        "column02": 21.04028158,
        "column03": 534,
        "column04": 495,
        "column05": 4,
        "column06": 583,
        "column07": 22.80015643,
        "column08": 0,
        "column09": 191,
        "column10": 392,
        "column11": 1436,
        "column12": 56.15956199,
        "column13": 4,
        "column14": 5,
        "column15": 77,
        "column16": 271,
        "column17": 29,
        "column18": 1,
        "column19": 24,
        "column20": 110,
        "column21": 100,
        "column22": 56,
        "column23": 415,
        "column24": 44,
        "column25": 163,
        "column26": 137,
        "column27": 0
      },
      {
        "citycode": 45405,
        "cityname": "川南町",
        "column01": 2558,
        "column02": 30.92733648,
        "column03": 2296,
        "column04": 2269,
        "column05": 262,
        "column06": 1703,
        "column07": 20.5900133,
        "column08": 0,
        "column09": 532,
        "column10": 1171,
        "column11": 3994,
        "column12": 48.28920324,
        "column13": 42,
        "column14": 14,
        "column15": 366,
        "column16": 890,
        "column17": 57,
        "column18": 20,
        "column19": 131,
        "column20": 263,
        "column21": 220,
        "column22": 188,
        "column23": 1073,
        "column24": 176,
        "column25": 320,
        "column26": 234,
        "column27": 16
      },
      {
        "citycode": 45406,
        "cityname": "都農町",
        "column01": 1392,
        "column02": 27.43397714,
        "column03": 1328,
        "column04": 1303,
        "column05": 64,
        "column06": 1194,
        "column07": 23.53173039,
        "column08": 3,
        "column09": 384,
        "column10": 807,
        "column11": 2472,
        "column12": 48.7189594,
        "column13": 29,
        "column14": 12,
        "column15": 232,
        "column16": 593,
        "column17": 52,
        "column18": 21,
        "column19": 54,
        "column20": 169,
        "column21": 147,
        "column22": 93,
        "column23": 608,
        "column24": 106,
        "column25": 202,
        "column26": 154,
        "column27": 16
      },
      {
        "citycode": 45421,
        "cityname": "門川町",
        "column01": 666,
        "column02": 7.742385492,
        "column03": 528,
        "column04": 467,
        "column05": 138,
        "column06": 2713,
        "column07": 31.53917694,
        "column08": 3,
        "column09": 983,
        "column10": 1727,
        "column11": 5202,
        "column12": 60.4743083,
        "column13": 22,
        "column14": 53,
        "column15": 332,
        "column16": 1295,
        "column17": 127,
        "column18": 84,
        "column19": 139,
        "column20": 294,
        "column21": 338,
        "column22": 278,
        "column23": 1463,
        "column24": 111,
        "column25": 445,
        "column26": 221,
        "column27": 21
      },
      {
        "citycode": 45429,
        "cityname": "諸塚村",
        "column01": 387,
        "column02": 39.89690722,
        "column03": 387,
        "column04": 218,
        "column05": 0,
        "column06": 159,
        "column07": 16.39175258,
        "column08": 0,
        "column09": 97,
        "column10": 62,
        "column11": 422,
        "column12": 43.50515464,
        "column13": 9,
        "column14": 1,
        "column15": 24,
        "column16": 60,
        "column17": 1,
        "column18": 1,
        "column19": 4,
        "column20": 26,
        "column21": 9,
        "column22": 49,
        "column23": 100,
        "column24": 29,
        "column25": 38,
        "column26": 71,
        "column27": 2
      },
      {
        "citycode": 45430,
        "cityname": "椎葉村",
        "column01": 514,
        "column02": 35.66967384,
        "column03": 514,
        "column04": 314,
        "column05": 0,
        "column06": 274,
        "column07": 19.01457321,
        "column08": 11,
        "column09": 206,
        "column10": 57,
        "column11": 653,
        "column12": 45.31575295,
        "column13": 2,
        "column14": 0,
        "column15": 30,
        "column16": 71,
        "column17": 8,
        "column18": 4,
        "column19": 34,
        "column20": 68,
        "column21": 14,
        "column22": 84,
        "column23": 158,
        "column24": 39,
        "column25": 35,
        "column26": 106,
        "column27": 0
      },
      {
        "citycode": 45431,
        "cityname": "美郷町",
        "column01": 865,
        "column02": 33.0910482,
        "column03": 864,
        "column04": 658,
        "column05": 1,
        "column06": 420,
        "column07": 16.06732976,
        "column08": 3,
        "column09": 251,
        "column10": 166,
        "column11": 1328,
        "column12": 50.80336649,
        "column13": 2,
        "column14": 6,
        "column15": 48,
        "column16": 202,
        "column17": 6,
        "column18": 4,
        "column19": 49,
        "column20": 89,
        "column21": 44,
        "column22": 88,
        "column23": 412,
        "column24": 142,
        "column25": 73,
        "column26": 163,
        "column27": 1
      },
      {
        "citycode": 45441,
        "cityname": "高千穂町",
        "column01": 1635,
        "column02": 25.03445108,
        "column03": 1631,
        "column04": 1528,
        "column05": 4,
        "column06": 1061,
        "column07": 16.24559792,
        "column08": 3,
        "column09": 710,
        "column10": 348,
        "column11": 3833,
        "column12": 58.68932782,
        "column13": 19,
        "column14": 15,
        "column15": 195,
        "column16": 754,
        "column17": 59,
        "column18": 47,
        "column19": 94,
        "column20": 465,
        "column21": 160,
        "column22": 277,
        "column23": 938,
        "column24": 211,
        "column25": 279,
        "column26": 320,
        "column27": 2
      },
      {
        "citycode": 45442,
        "cityname": "日之影町",
        "column01": 774,
        "column02": 35.83333333,
        "column03": 774,
        "column04": 682,
        "column05": 0,
        "column06": 384,
        "column07": 17.77777778,
        "column08": 10,
        "column09": 240,
        "column10": 134,
        "column11": 1000,
        "column12": 46.2962963,
        "column13": 8,
        "column14": 4,
        "column15": 64,
        "column16": 213,
        "column17": 16,
        "column18": 8,
        "column19": 14,
        "column20": 76,
        "column21": 48,
        "column22": 64,
        "column23": 259,
        "column24": 38,
        "column25": 73,
        "column26": 115,
        "column27": 2
      },
      {
        "citycode": 45443,
        "cityname": "五ヶ瀬町",
        "column01": 746,
        "column02": 37.63874874,
        "column03": 739,
        "column04": 617,
        "column05": 7,
        "column06": 290,
        "column07": 14.63168517,
        "column08": 0,
        "column09": 190,
        "column10": 100,
        "column11": 946,
        "column12": 47.72956609,
        "column13": 0,
        "column14": 0,
        "column15": 27,
        "column16": 163,
        "column17": 7,
        "column18": 5,
        "column19": 14,
        "column20": 87,
        "column21": 38,
        "column22": 125,
        "column23": 278,
        "column24": 42,
        "column25": 65,
        "column26": 95,
        "column27": 0
      }
    ]
};

export const zyuugyouzyouchii = {
  koyousya: {
    column: "column01",
    statName: '雇用者',
    unit: '人',
  },
  koyousyawariai: {
    column: "column02",
    statName: '雇用者割合(対就業者)',
    unit: '％',
  },
  yakuin: {
    column: "column03",
    statName: '役員',
    unit: '人',
  },
  yakuinwariai: {
    column: "column04",
    statName: '役員割合(対就業者)',
    unit: '％',
  },
  yatoibito: {
    column: "column05",
    statName: '雇人のある業主',
    unit: '人',
  },
  yatoibitowariai: {
    column: "column06",
    statName: '雇人のある業主割合(対就業者)',
    unit: '％',
  },
  yatoibitonai: {
    column: "column07",
    statName: '雇人のない業主',
    unit: '人',
  },
  yatoibitonaiwariai: {
    column: "column08",
    statName: '雇人のない業主割合(対就業者)',
    unit: '％',
  },
  kazoku: {
    column: "column09",
    statName: '家族従業者',
    unit: '人',
  },
  kazokuwariai: {
    column: "column10",
    statName: '家族従業者割合(対就業者)',
    unit: '％',
  },
  data:
    [
      {
        "citycode": 45201,
        "cityname": "宮崎市",
        "column01": 148104,
        "column02": 79.10313039,
        "column03": 8649,
        "column04": 4.619476684,
        "column05": 4727,
        "column06": 2.524715722,
        "column07": 12980,
        "column08": 6.93268671,
        "column09": 7638,
        "column10": 4.079496232
      },
      {
        "citycode": 45202,
        "cityname": "都城市",
        "column01": 59894,
        "column02": 77.75210302,
        "column03": 3152,
        "column04": 4.091806003,
        "column05": 2120,
        "column06": 2.752103022,
        "column07": 6715,
        "column08": 8.717156506,
        "column09": 4175,
        "column10": 5.419825527
      },
      {
        "citycode": 45203,
        "cityname": "延岡市",
        "column01": 44328,
        "column02": 79.16138365,
        "column03": 2565,
        "column04": 4.580602532,
        "column05": 1524,
        "column06": 2.72157437,
        "column07": 4612,
        "column08": 8.236155508,
        "column09": 2152,
        "column10": 3.843063021
      },
      {
        "citycode": 45204,
        "cityname": "日南市",
        "column01": 18759,
        "column02": 78.29952417,
        "column03": 1024,
        "column04": 4.274146423,
        "column05": 757,
        "column06": 3.159696135,
        "column07": 1912,
        "column08": 7.980632774,
        "column09": 1328,
        "column10": 5.543033642
      },
      {
        "citycode": 45205,
        "cityname": "小林市",
        "column01": 15484,
        "column02": 68.08847456,
        "column03": 898,
        "column04": 3.948814916,
        "column05": 634,
        "column06": 2.787916099,
        "column07": 3160,
        "column08": 13.89560705,
        "column09": 2205,
        "column10": 9.696143529
      },
      {
        "citycode": 45206,
        "cityname": "日向市",
        "column01": 23181,
        "column02": 78.72376554,
        "column03": 1373,
        "column04": 4.662772533,
        "column05": 886,
        "column06": 3.008897643,
        "column07": 2368,
        "column08": 8.041839299,
        "column09": 1303,
        "column10": 4.425049243
      },
      {
        "citycode": 45207,
        "cityname": "串間市",
        "column01": 5745,
        "column02": 65.36579816,
        "column03": 308,
        "column04": 3.504380476,
        "column05": 337,
        "column06": 3.834338378,
        "column07": 1218,
        "column08": 13.85823188,
        "column09": 1162,
        "column10": 13.22107179
      },
      {
        "citycode": 45208,
        "cityname": "西都市",
        "column01": 9557,
        "column02": 64.02063237,
        "column03": 471,
        "column04": 3.155144695,
        "column05": 553,
        "column06": 3.704448017,
        "column07": 2016,
        "column08": 13.50482315,
        "column09": 2124,
        "column10": 14.22829582
      },
      {
        "citycode": 45209,
        "cityname": "えびの市",
        "column01": 6126,
        "column02": 65.93477559,
        "column03": 395,
        "column04": 4.251426111,
        "column05": 252,
        "column06": 2.712302228,
        "column07": 1447,
        "column08": 15.5742116,
        "column09": 989,
        "column10": 10.64470993
      },
      {
        "citycode": 45341,
        "cityname": "三股町",
        "column01": 9704,
        "column02": 81.3616165,
        "column03": 445,
        "column04": 3.731030435,
        "column05": 256,
        "column06": 2.146390542,
        "column07": 974,
        "column08": 8.166345267,
        "column09": 478,
        "column10": 4.007713591
      },
      {
        "citycode": 45361,
        "cityname": "高原町",
        "column01": 3109,
        "column02": 66.81710724,
        "column03": 145,
        "column04": 3.116269074,
        "column05": 109,
        "column06": 2.342574683,
        "column07": 793,
        "column08": 17.04276811,
        "column09": 485,
        "column10": 10.42338276
      },
      {
        "citycode": 45382,
        "cityname": "国富町",
        "column01": 6715,
        "column02": 68.2696218,
        "column03": 398,
        "column04": 4.046360309,
        "column05": 283,
        "column06": 2.877185848,
        "column07": 1284,
        "column08": 13.05408703,
        "column09": 1049,
        "column10": 10.66490443
      },
      {
        "citycode": 45383,
        "cityname": "綾町",
        "column01": 2491,
        "column02": 67.56170328,
        "column03": 141,
        "column04": 3.824247356,
        "column05": 116,
        "column06": 3.146189314,
        "column07": 560,
        "column08": 15.18850014,
        "column09": 376,
        "column10": 10.19799295
      },
      {
        "citycode": 45401,
        "cityname": "高鍋町",
        "column01": 7579,
        "column02": 76.95197482,
        "column03": 370,
        "column04": 3.756726571,
        "column05": 313,
        "column06": 3.177987613,
        "column07": 859,
        "column08": 8.721697634,
        "column09": 603,
        "column10": 6.12244898
      },
      {
        "citycode": 45402,
        "cityname": "新富町",
        "column01": 6680,
        "column02": 73.44694887,
        "column03": 275,
        "column04": 3.023639362,
        "column05": 306,
        "column06": 3.364485981,
        "column07": 946,
        "column08": 10.40131941,
        "column09": 873,
        "column10": 9.598680594
      },
      {
        "citycode": 45403,
        "cityname": "西米良村",
        "column01": 371,
        "column02": 67.45454545,
        "column03": 17,
        "column04": 3.090909091,
        "column05": 21,
        "column06": 3.818181818,
        "column07": 97,
        "column08": 17.63636364,
        "column09": 44,
        "column10": 8
      },
      {
        "citycode": 45404,
        "cityname": "木城町",
        "column01": 1827,
        "column02": 71.45091905,
        "column03": 83,
        "column04": 3.245991396,
        "column05": 85,
        "column06": 3.324208056,
        "column07": 328,
        "column08": 12.82753226,
        "column09": 231,
        "column10": 9.034024247
      },
      {
        "citycode": 45405,
        "cityname": "川南町",
        "column01": 5516,
        "column02": 66.69084754,
        "column03": 251,
        "column04": 3.034699553,
        "column05": 341,
        "column06": 4.122838834,
        "column07": 1123,
        "column08": 13.57756015,
        "column09": 1020,
        "column10": 12.33224519
      },
      {
        "citycode": 45406,
        "cityname": "都農町",
        "column01": 3329,
        "column02": 65.60898699,
        "column03": 139,
        "column04": 2.73945605,
        "column05": 286,
        "column06": 5.636578636,
        "column07": 617,
        "column08": 12.16003153,
        "column09": 685,
        "column10": 13.50019708
      },
      {
        "citycode": 45421,
        "cityname": "門川町",
        "column01": 6822,
        "column02": 79.30713787,
        "column03": 375,
        "column04": 4.35945129,
        "column05": 268,
        "column06": 3.115554522,
        "column07": 687,
        "column08": 7.986514764,
        "column09": 419,
        "column10": 4.870960242
      },
      {
        "citycode": 45429,
        "cityname": "諸塚村",
        "column01": 615,
        "column02": 63.40206186,
        "column03": 33,
        "column04": 3.402061856,
        "column05": 19,
        "column06": 1.958762887,
        "column07": 184,
        "column08": 18.96907216,
        "column09": 115,
        "column10": 11.8556701
      },
      {
        "citycode": 45430,
        "cityname": "椎葉村",
        "column01": 870,
        "column02": 60.37473976,
        "column03": 56,
        "column04": 3.886190146,
        "column05": 40,
        "column06": 2.775850104,
        "column07": 283,
        "column08": 19.63913949,
        "column09": 190,
        "column10": 13.18528799
      },
      {
        "citycode": 45431,
        "cityname": "美郷町",
        "column01": 1617,
        "column02": 61.85921959,
        "column03": 56,
        "column04": 2.142310635,
        "column05": 269,
        "column06": 10.29074216,
        "column07": 362,
        "column08": 13.84850803,
        "column09": 304,
        "column10": 11.6296863
      },
      {
        "citycode": 45441,
        "cityname": "高千穂町",
        "column01": 4187,
        "column02": 64.10963099,
        "column03": 234,
        "column04": 3.582912265,
        "column05": 161,
        "column06": 2.465166131,
        "column07": 1015,
        "column08": 15.54126474,
        "column09": 920,
        "column10": 14.0866636
      },
      {
        "citycode": 45442,
        "cityname": "日之影町",
        "column01": 1252,
        "column02": 57.96296296,
        "column03": 73,
        "column04": 3.37962963,
        "column05": 45,
        "column06": 2.083333333,
        "column07": 422,
        "column08": 19.53703704,
        "column09": 362,
        "column10": 16.75925926
      },
      {
        "citycode": 45443,
        "cityname": "五ヶ瀬町",
        "column01": 1184,
        "column02": 59.73763875,
        "column03": 48,
        "column04": 2.421796165,
        "column05": 45,
        "column06": 2.270433905,
        "column07": 385,
        "column08": 19.42482341,
        "column09": 318,
        "column10": 16.0443996
      }
    ]
};

export const shicyousonmin = {
  souseisan: {
    column: "column01",
    statName: '市町村内総生産',
    unit: '百万円',
  },
  jitugaku: {
    column: "column02",
    statName: '就業者1人当たり実額',
    unit: '千円',
  },
  suizyun: {
    column: "column03",
    statName: '就業者1人当たり水準',
    unit: '％',
  },
  syotoku: {
    column: "column04",
    statName: '(参考)市町村民所得(分配)',
    unit: '百万円',
  },
  data:
    [
      {
        "citycode": 45201,
        "cityname": "宮崎市",
        "column01": 1362245.596,
        "column02": 7495.613867,
        "column03": 105.2115156,
        "column04": 1107647.414
      },
      {
        "citycode": 45202,
        "cityname": "都城市",
        "column01": 617669.9896,
        "column02": 8106.808095,
        "column03": 113.7904889,
        "column04": 412347.0698
      },
      {
        "citycode": 45203,
        "cityname": "延岡市",
        "column01": 413939.8151,
        "column02": 7487.428954,
        "column03": 105.0966288,
        "column04": 293319.1491
      },
      {
        "citycode": 45204,
        "cityname": "日南市",
        "column01": 180557.2032,
        "column02": 7491.825159,
        "column03": 105.1583358,
        "column04": 113306.5633
      },
      {
        "citycode": 45205,
        "cityname": "小林市",
        "column01": 133140.1975,
        "column02": 5917.384031,
        "column03": 83.05883326,
        "column04": 97377.1157
      },
      {
        "citycode": 45206,
        "cityname": "日向市",
        "column01": 196872.9683,
        "column02": 6780.611544,
        "column03": 95.17544928,
        "column04": 145978.0966
      },
      {
        "citycode": 45207,
        "cityname": "串間市",
        "column01": 52980.60352,
        "column02": 5977.693273,
        "column03": 83.90535857,
        "column04": 35701.47839
      },
      {
        "citycode": 45208,
        "cityname": "西都市",
        "column01": 87317.23928,
        "column02": 5860.714545,
        "column03": 82.26339708,
        "column04": 57516.73569
      },
      {
        "citycode": 45209,
        "cityname": "えびの市",
        "column01": 70173.78888,
        "column02": 7501.996289,
        "column03": 105.3011019,
        "column04": 37521.18902
      },
      {
        "citycode": 45341,
        "cityname": "三股町",
        "column01": 49602.10521,
        "column02": 4206.547093,
        "column03": 59.04482314,
        "column04": 50165.78696
      },
      {
        "citycode": 45361,
        "cityname": "高原町",
        "column01": 24468.2399,
        "column02": 5204.648058,
        "column03": 73.05457834,
        "column04": 16309.47138
      },
      {
        "citycode": 45382,
        "cityname": "国富町",
        "column01": 66033.46333,
        "column02": 6723.059591,
        "column03": 94.36762642,
        "column04": 42839.76425
      },
      {
        "citycode": 45383,
        "cityname": "綾町",
        "column01": 24483.73587,
        "column02": 6692.38966,
        "column03": 93.93713067,
        "column04": 13505.17276
      },
      {
        "citycode": 45401,
        "cityname": "高鍋町",
        "column01": 62077.54124,
        "column02": 6396.319146,
        "column03": 89.78136329,
        "column04": 44674.43453
      },
      {
        "citycode": 45402,
        "cityname": "新富町",
        "column01": 64393.74935,
        "column02": 7093.171147,
        "column03": 99.56266427,
        "column04": 35765.14562
      },
      {
        "citycode": 45403,
        "cityname": "西米良村",
        "column01": 7514.255274,
        "column02": 13452.54706,
        "column03": 188.8254772,
        "column04": 2278.219902
      },
      {
        "citycode": 45404,
        "cityname": "木城町",
        "column01": 18216.21013,
        "column02": 7211.732839,
        "column03": 101.2268449,
        "column04": 9617.580844
      },
      {
        "citycode": 45405,
        "cityname": "川南町",
        "column01": 55757.43715,
        "column02": 6774.229004,
        "column03": 95.08586132,
        "column04": 33082.21529
      },
      {
        "citycode": 45406,
        "cityname": "都農町",
        "column01": 23714.9367,
        "column02": 4686.64894,
        "column03": 65.78372992,
        "column04": 18110.92399
      },
      {
        "citycode": 45421,
        "cityname": "門川町",
        "column01": 42170.03415,
        "column02": 4967.150376,
        "column03": 69.72096331,
        "column04": 34115.77268
      },
      {
        "citycode": 45429,
        "cityname": "諸塚村",
        "column01": 7151.646255,
        "column02": 7496.101955,
        "column03": 105.2183666,
        "column04": 3186.934396
      },
      {
        "citycode": 45430,
        "cityname": "椎葉村",
        "column01": 11090.57523,
        "column02": 7682.180446,
        "column03": 107.8302408,
        "column04": 4747.3598
      },
      {
        "citycode": 45431,
        "cityname": "美郷町",
        "column01": 16258.8659,
        "column02": 6112.737812,
        "column03": 85.80089919,
        "column04": 8214.968561
      },
      {
        "citycode": 45441,
        "cityname": "高千穂町",
        "column01": 33178.82399,
        "column02": 5022.479168,
        "column03": 70.49758095,
        "column04": 23521.89837
      },
      {
        "citycode": 45442,
        "cityname": "日之影町",
        "column01": 13038.10141,
        "column02": 6014.945221,
        "column03": 84.42824221,
        "column04": 6367.358857
      },
      {
        "citycode": 45443,
        "cityname": "五ヶ瀬町",
        "column01": 9394.028615,
        "column02": 4722.693367,
        "column03": 66.2896643,
        "column04": 5930.55783
      }
    ]
};

export const seisankatudou = {
  nouringyou: {
    column: "column01",
    statName: '農林業経営体数',
    unit: '経営体',
  },
  noukasuu: {
    column: "column02",
    statName: '総農家数',
    unit: '戸',
  },
  syugyounoukasuu: {
    column: "column03",
    statName: '主業農家数(販売農家)',
    unit: '戸',
  },
  syugyounoukawariai: {
    column: "column04",
    statName: '主業農家割合',
    unit: '％',
  },
  nougyoujyuujisyasuu: {
    column: "column05",
    statName: '農業従事者数(販売農家)',
    unit: '人',
  },
  nougyousyuugyoujinkou: {
    column: "column06",
    statName: '農業就業人口(販売農家)',
    unit: '人',
  },
  kikanteki: {
    column: "column07",
    statName: '基幹的農業従事者数(販売農家)',
    unit: '人',
  },
  soumenseki: {
    column: "column08",
    statName: '経営耕地総面積(農業経営体)',
    unit: 'ha',
  },
  atarisoumenseki: {
    column: "column09",
    statName: '1経営体当たり経営耕地総面積',
    unit: 'ha',
  },
  tanoaru: {
    column: "column10",
    statName: '田のある農業経営体数',
    unit: '経営体',
  },
  ataritanoaru: {
    column: "column11",
    statName: '1経営体当たり田の面積',
    unit: 'ha',
  },
  hatakearu: {
    column: "column12",
    statName: '畑のある農業経営体数',
    unit: '経営体',
  },
  atarihatakearu: {
    column: "column13",
    statName: '1経営体当たり畑の面積',
    unit: 'ha',
  },
  jyuenchi: {
    column: "column14",
    statName: '樹園地のある農業経営体数',
    unit: '経営体',
  },
  atarijyuenchi: {
    column: "column15",
    statName: '1経営体当たり樹園地の面積',
    unit: 'ha',
  },
  suitou: {
    column: "column16",
    statName: '水稲収穫量',
    unit: 't',
  },
  suitousouki: {
    column: "column17",
    statName: '水稲収穫量早期栽培',
    unit: 't',
  },
  suitouhutuu: {
    column: "column18",
    statName: '水稲収穫量普通栽培',
    unit: 't',
  },
  mugi: {
    column: "column19",
    statName: '麦収穫量',
    unit: 't',
  },
  tabako: {
    column: "column20",
    statName: '葉たばこ販売重量',
    unit: 't',
  },
  nyuuyougyuu: {
    column: "column21",
    statName: '乳用牛飼養頭数',
    unit: '頭',
  },
  nikuyougyuu: {
    column: "column22",
    statName: '肉用牛飼養頭数',
    unit: '頭',
  },
  buta: {
    column: "column23",
    statName: '飼養頭数',
    unit: '頭',
  },
  sairankei: {
    column: "column24",
    statName: '採卵鶏飼養羽数',
    unit: '千羽',
  },
  bro: {
    column: "column25",
    statName: 'ブロイラー出荷羽数',
    unit: '千羽',
  },
  seizouhin: {
    column: "column26",
    statName: '製造品出荷額等(製造、加工、その他)',
    unit: '万円',
  },
  atari0seizouhin: {
    column: "column27",
    statName: '1事業所当たり製造品出荷額等(製造、加工、その他)',
    unit: '万円',
  },
  atari1seizouhin: {
    column: "column28",
    statName: '従業者1人当たり製造品出荷額等(製造、加工、その他)',
    unit: '万円',
  },
  jigyousyosuu: {
    column: "column29",
    statName: '事業所数',
    unit: '所',
  },
  jyuugyousyasuu: {
    column: "column30",
    statName: '従業者数',
    unit: '人',
  },
  atarijyuugyousyasuu: {
    column: "column31",
    statName: '1事業所当たり従業者数',
    unit: '人',
  },
  nenkanhanbaigaku: {
    column: "column32",
    statName: '商業年間商品販売額',
    unit: '百万円',
  },
  atari0nenkanhanbaigaku: {
    column: "column33",
    statName: '1商店当たり商業年間商品販売額',
    unit: '百万円',
  },
  atari1nenkanhanbaigaku: {
    column: "column34",
    statName: '従業者1人当たり商業年間商品販売額',
    unit: '百万円',
  },
  syoutensuu: {
    column: "column35",
    statName: '商店数',
    unit: '店',
  },
  jyuugyousyasuuS: {
    column: "column36",
    statName: '従業者数',
    unit: '人',
  },
  atarijyuugyousyasuuS: {
    column: "column37",
    statName: '1商店当たり従業者数',
    unit: '人',
  },
  data:
    [
      {
        "citycode": 45201,
        "cityname": "宮崎市",
        "column01": 3773,
        "column02": 5202,
        "column03": 1616,
        "column04": 31.06497501,
        "column05": 8821,
        "column06": 7304,
        "column07": 6864,
        "column08": 5661,
        "column09": 1.54,
        "column10": 3302,
        "column11": 1.05,
        "column12": 2064,
        "column13": 0.93,
        "column14": 419,
        "column15": 0.68,
        "column16": 12200,
        "column17": 9430,
        "column18": 2740,
        "column19": 43,
        "column20": 674,
        "column21": 101,
        "column22": 12672,
        "column23": 13530,
        "column24": 480,
        "column25": 2748,
        "column26": 20770337,
        "column27": 63908.72923,
        "column28": 1823.558999,
        "column29": 325,
        "column30": 11390,
        "column31": 35.04615385,
        "column32": 1317230,
        "column33": 367.6332682,
        "column34": 43.96041917,
        "column35": 3583,
        "column36": 29964,
        "column37": 8.362824449
      },
      {
        "citycode": 45202,
        "cityname": "都城市",
        "column01": 3700,
        "column02": 6581,
        "column03": 1061,
        "column04": 16.12216988,
        "column05": 7548,
        "column06": 5867,
        "column07": 5447,
        "column08": 8229,
        "column09": 2.31,
        "column10": 3443,
        "column11": 1.15,
        "column12": 2406,
        "column13": 1.67,
        "column14": 101,
        "column15": 2.4,
        "column16": 15700,
        "column17": "－",
        "column18": 15700,
        "column19": 12,
        "column20": 52,
        "column21": 7090,
        "column22": 51269,
        "column23": 216803,
        "column24": 1626,
        "column25": 19792,
        "column26": 38550683,
        "column27": 138174.491,
        "column28": 3272.553735,
        "column29": 279,
        "column30": 11780,
        "column31": 42.22222222,
        "column32": 372530,
        "column33": 215.2108608,
        "column34": 30.74440868,
        "column35": 1731,
        "column36": 12117,
        "column37": 7
      },
      {
        "citycode": 45203,
        "cityname": "延岡市",
        "column01": 1662,
        "column02": 2447,
        "column03": 278,
        "column04": 11.36085002,
        "column05": 3614,
        "column06": 2290,
        "column07": 1992,
        "column08": 1541,
        "column09": 1.01,
        "column10": 1428,
        "column11": 0.83,
        "column12": 957,
        "column13": 0.19,
        "column14": 301,
        "column15": 0.57,
        "column16": 4380,
        "column17": 115,
        "column18": 4270,
        "column19": 63,
        "column20": 14,
        "column21": "x",
        "column22": "x",
        "column23": 6850,
        "column24": 39,
        "column25": 442,
        "column26": 31143955,
        "column27": 151921.7317,
        "column28": 4048.349799,
        "column29": 205,
        "column30": 7693,
        "column31": 37.52682927,
        "column32": 191033,
        "column33": 145.1618541,
        "column34": 23.66026753,
        "column35": 1316,
        "column36": 8074,
        "column37": 6.135258359
      },
      {
        "citycode": 45204,
        "cityname": "日南市",
        "column01": 1188,
        "column02": 1642,
        "column03": 324,
        "column04": 19.7320341,
        "column05": 2508,
        "column06": 1838,
        "column07": 1691,
        "column08": 1851,
        "column09": 1.72,
        "column10": 842,
        "column11": 1.34,
        "column12": 402,
        "column13": 0.41,
        "column14": 474,
        "column15": 1.19,
        "column16": 4070,
        "column17": 3800,
        "column18": 270,
        "column19": 2,
        "column20": 23,
        "column21": "x",
        "column22": "x",
        "column23": 63741,
        "column24": 74,
        "column25": 2023,
        "column26": 7442553,
        "column27": 74425.53,
        "column28": 2226.975763,
        "column29": 100,
        "column30": 3342,
        "column31": 33.42,
        "column32": 67862,
        "column33": 115.2156197,
        "column34": 21.49572379,
        "column35": 589,
        "column36": 3157,
        "column37": 5.359932088
      },
      {
        "citycode": 45205,
        "cityname": "小林市",
        "column01": 2375,
        "column02": 3503,
        "column03": 807,
        "column04": 23.03739652,
        "column05": 5211,
        "column06": 4082,
        "column07": 3769,
        "column08": 4596,
        "column09": 2,
        "column10": 2123,
        "column11": 0.76,
        "column12": 1757,
        "column13": 1.51,
        "column14": 326,
        "column15": 1,
        "column16": 5120,
        "column17": "－",
        "column18": 5120,
        "column19": 3,
        "column20": 71,
        "column21": 1813,
        "column22": 27840,
        "column23": 31537,
        "column24": 10,
        "column25": 7443,
        "column26": 3657781,
        "column27": 58060.01587,
        "column28": 1885.454124,
        "column29": 63,
        "column30": 1940,
        "column31": 30.79365079,
        "column32": 68365,
        "column33": 129.4791667,
        "column34": 20.75440194,
        "column35": 528,
        "column36": 3294,
        "column37": 6.238636364
      },
      {
        "citycode": 45206,
        "cityname": "日向市",
        "column01": 863,
        "column02": 1320,
        "column03": 167,
        "column04": 12.65151515,
        "column05": 1842,
        "column06": 1181,
        "column07": 1053,
        "column08": 824,
        "column09": 1.04,
        "column10": 746,
        "column11": 0.74,
        "column12": 524,
        "column13": 0.3,
        "column14": 149,
        "column15": 0.74,
        "column16": 2240,
        "column17": 1100,
        "column18": 1140,
        "column19": "x",
        "column20": 0,
        "column21": "x",
        "column22": "x",
        "column23": 9023,
        "column24": 395,
        "column25": 14115,
        "column26": 16186134,
        "column27": 134884.45,
        "column28": 3071.372676,
        "column29": 120,
        "column30": 5270,
        "column31": 43.91666667,
        "column32": 111796,
        "column33": 143.8815959,
        "column34": 24.17210811,
        "column35": 777,
        "column36": 4625,
        "column37": 5.952380952
      },
      {
        "citycode": 45207,
        "cityname": "串間市",
        "column01": 992,
        "column02": 1241,
        "column03": 453,
        "column04": 36.50282031,
        "column05": 2416,
        "column06": 1926,
        "column07": 1863,
        "column08": 2244,
        "column09": 2.32,
        "column10": 887,
        "column11": 1.39,
        "column12": 577,
        "column13": 1.53,
        "column14": 159,
        "column15": 0.85,
        "column16": 3320,
        "column17": 3150,
        "column18": 168,
        "column19": 1,
        "column20": 58,
        "column21": 614,
        "column22": "x",
        "column23": 4633,
        "column24": "ｘ",
        "column25": 610,
        "column26": 385516,
        "column27": 11682.30303,
        "column28": 752.9609375,
        "column29": 33,
        "column30": 512,
        "column31": 15.51515152,
        "column32": 17719,
        "column33": 93.75132275,
        "column34": 19.88664422,
        "column35": 189,
        "column36": 891,
        "column37": 4.714285714
      },
      {
        "citycode": 45208,
        "cityname": "西都市",
        "column01": 1605,
        "column02": 1958,
        "column03": 776,
        "column04": 39.63227783,
        "column05": 4061,
        "column06": 3356,
        "column07": 3186,
        "column08": 3468,
        "column09": 2.21,
        "column10": 1469,
        "column11": 1.52,
        "column12": 776,
        "column13": 1.44,
        "column14": 125,
        "column15": 0.96,
        "column16": 5690,
        "column17": 5010,
        "column18": 682,
        "column19": 4,
        "column20": 97,
        "column21": 562,
        "column22": "x",
        "column23": 5340,
        "column24": 11,
        "column25": 2538,
        "column26": 2652016,
        "column27": 66300.4,
        "column28": 1750.505611,
        "column29": 40,
        "column30": 1515,
        "column31": 37.875,
        "column32": 31464,
        "column33": 104.5315615,
        "column34": 19.77624136,
        "column35": 301,
        "column36": 1591,
        "column37": 5.285714286
      },
      {
        "citycode": 45209,
        "cityname": "えびの市",
        "column01": 1622,
        "column02": 2261,
        "column03": 341,
        "column04": 15.0818222,
        "column05": 3448,
        "column06": 2310,
        "column07": 2052,
        "column08": 2861,
        "column09": 1.81,
        "column10": 1527,
        "column11": 1.23,
        "column12": 853,
        "column13": 1.12,
        "column14": 79,
        "column15": 0.38,
        "column16": 6130,
        "column17": 0,
        "column18": 6130,
        "column19": 3,
        "column20": 7,
        "column21": 666,
        "column22": 23070,
        "column23": 53239,
        "column24": 168,
        "column25": 4948,
        "column26": 1404357,
        "column27": 43886.15625,
        "column28": 1171.273561,
        "column29": 32,
        "column30": 1199,
        "column31": 37.46875,
        "column32": 19618,
        "column33": 86.04385965,
        "column34": 18.75525813,
        "column35": 228,
        "column36": 1046,
        "column37": 4.587719298
      },
      {
        "citycode": 45341,
        "cityname": "三股町",
        "column01": 550,
        "column02": 902,
        "column03": 125,
        "column04": 13.85809313,
        "column05": 1058,
        "column06": 750,
        "column07": 686,
        "column08": 916,
        "column09": 1.73,
        "column10": 519,
        "column11": 1.09,
        "column12": 306,
        "column13": 1.09,
        "column14": 24,
        "column15": 0.63,
        "column16": 1800,
        "column17": 0,
        "column18": 1800,
        "column19": 2,
        "column20": 6,
        "column21": 356,
        "column22": "x",
        "column23": "x",
        "column24": "x",
        "column25": 2855,
        "column26": 1146202,
        "column27": 24917.43478,
        "column28": 1315.960964,
        "column29": 46,
        "column30": 871,
        "column31": 18.93478261,
        "column32": 28455,
        "column33": 178.9622642,
        "column34": 22.96610169,
        "column35": 159,
        "column36": 1239,
        "column37": 7.79245283
      },
      {
        "citycode": 45361,
        "cityname": "高原町",
        "column01": 738,
        "column02": 1063,
        "column03": 243,
        "column04": 22.85983067,
        "column05": 1563,
        "column06": 1141,
        "column07": 1093,
        "column08": 1506,
        "column09": 2.13,
        "column10": 670,
        "column11": 1.03,
        "column12": 530,
        "column13": 1.49,
        "column14": 31,
        "column15": 0.94,
        "column16": 2130,
        "column17": "－",
        "column18": 2130,
        "column19": "x",
        "column20": 19,
        "column21": 633,
        "column22": "x",
        "column23": "x",
        "column24": 30,
        "column25": 1353,
        "column26": 432510,
        "column27": 17300.4,
        "column28": 1172.113821,
        "column29": 25,
        "column30": 369,
        "column31": 14.76,
        "column32": 6281,
        "column33": 74.77380952,
        "column34": 16.39947781,
        "column35": 84,
        "column36": 383,
        "column37": 4.55952381
      },
      {
        "citycode": 45382,
        "cityname": "国富町",
        "column01": 993,
        "column02": 1300,
        "column03": 396,
        "column04": 30.46153846,
        "column05": 2221,
        "column06": 1810,
        "column07": 1673,
        "column08": 1907,
        "column09": 1.97,
        "column10": 931,
        "column11": 1.39,
        "column12": 468,
        "column13": 1.19,
        "column14": 59,
        "column15": 1.03,
        "column16": 2320,
        "column17": 536,
        "column18": 1790,
        "column19": 4,
        "column20": 214,
        "column21": "-",
        "column22": "x",
        "column23": 9801,
        "column24": 20,
        "column25": 1200,
        "column26": 9429753,
        "column27": 254858.1892,
        "column28": 4803.745797,
        "column29": 37,
        "column30": 1963,
        "column31": 53.05405405,
        "column32": 18390,
        "column33": 112.1341463,
        "column34": 18.9392379,
        "column35": 164,
        "column36": 971,
        "column37": 5.920731707
      },
      {
        "citycode": 45383,
        "cityname": "綾町",
        "column01": 364,
        "column02": 465,
        "column03": 158,
        "column04": 33.97849462,
        "column05": 743,
        "column06": 612,
        "column07": 568,
        "column08": 456,
        "column09": 1.32,
        "column10": 297,
        "column11": 0.8,
        "column12": 169,
        "column13": 0.93,
        "column14": 88,
        "column15": 0.69,
        "column16": 561,
        "column17": 37,
        "column18": 524,
        "column19": 3,
        "column20": "x",
        "column21": 78,
        "column22": "x",
        "column23": 15310,
        "column24": 0,
        "column25": "-",
        "column26": 1389178,
        "column27": 77176.55556,
        "column28": 3150.063492,
        "column29": 18,
        "column30": 441,
        "column31": 24.5,
        "column32": 11658,
        "column33": 147.5696203,
        "column34": 24.18672199,
        "column35": 79,
        "column36": 482,
        "column37": 6.101265823
      },
      {
        "citycode": 45401,
        "cityname": "高鍋町",
        "column01": 347,
        "column02": 462,
        "column03": 157,
        "column04": 33.98268398,
        "column05": 828,
        "column06": 652,
        "column07": 631,
        "column08": 1008,
        "column09": 3.06,
        "column10": 275,
        "column11": 1.32,
        "column12": 232,
        "column13": 2.41,
        "column14": 32,
        "column15": 2.72,
        "column16": 1530,
        "column17": 1490,
        "column18": 37,
        "column19": 1,
        "column20": "x",
        "column21": "-",
        "column22": "x",
        "column23": 4287,
        "column24": "x",
        "column25": 2714,
        "column26": 2070950,
        "column27": 147925,
        "column28": 3406.167763,
        "column29": 14,
        "column30": 608,
        "column31": 43.42857143,
        "column32": 39764,
        "column33": 145.6556777,
        "column34": 25.45710627,
        "column35": 273,
        "column36": 1562,
        "column37": 5.721611722
      },
      {
        "citycode": 45402,
        "cityname": "新富町",
        "column01": 734,
        "column02": 879,
        "column03": 360,
        "column04": 40.9556314,
        "column05": 1726,
        "column06": 1391,
        "column07": 1337,
        "column08": 1841,
        "column09": 2.62,
        "column10": 624,
        "column11": 1.46,
        "column12": 351,
        "column13": 2.45,
        "column14": 31,
        "column15": 2.16,
        "column16": 2310,
        "column17": 2220,
        "column18": 88,
        "column19": 68,
        "column20": 15,
        "column21": 796,
        "column22": "x",
        "column23": "x",
        "column24": 1516,
        "column25": 882,
        "column26": 2903592,
        "column27": 100123.8621,
        "column28": 2706.050326,
        "column29": 29,
        "column30": 1073,
        "column31": 37,
        "column32": 23192,
        "column33": 152.5789474,
        "column34": 30.92266667,
        "column35": 152,
        "column36": 750,
        "column37": 4.934210526
      },
      {
        "citycode": 45403,
        "cityname": "西米良村",
        "column01": 150,
        "column02": 139,
        "column03": 16,
        "column04": 11.51079137,
        "column05": 195,
        "column06": 101,
        "column07": 96,
        "column08": 50,
        "column09": 0.53,
        "column10": 78,
        "column11": 0.32,
        "column12": 53,
        "column13": 0.13,
        "column14": 52,
        "column15": 0.35,
        "column16": 94,
        "column17": 0,
        "column18": 94,
        "column19": 0,
        "column20": 0,
        "column21": "-",
        "column22": 162,
        "column23": "-",
        "column24": "-",
        "column25": "-",
        "column26": "X",
        "column27": "x",
        "column28": "x",
        "column29": 2,
        "column30": 26,
        "column31": 13,
        "column32": 368,
        "column33": 16.72727273,
        "column34": 8.975609756,
        "column35": 22,
        "column36": 41,
        "column37": 1.863636364
      },
      {
        "citycode": 45404,
        "cityname": "木城町",
        "column01": 314,
        "column02": 400,
        "column03": 100,
        "column04": 25,
        "column05": 630,
        "column06": 484,
        "column07": 446,
        "column08": 669,
        "column09": 2.26,
        "column10": 257,
        "column11": 1.33,
        "column12": 158,
        "column13": 1.89,
        "column14": 32,
        "column15": 0.84,
        "column16": 1100,
        "column17": 1000,
        "column18": 97,
        "column19": 1,
        "column20": 0,
        "column21": "x",
        "column22": "x",
        "column23": "x",
        "column24": "x",
        "column25": 1649,
        "column26": 3994870,
        "column27": 332905.8333,
        "column28": 3525.92233,
        "column29": 12,
        "column30": 1133,
        "column31": 94.41666667,
        "column32": 3367,
        "column33": 76.52272727,
        "column34": 15.73364486,
        "column35": 44,
        "column36": 214,
        "column37": 4.863636364
      },
      {
        "citycode": 45405,
        "cityname": "川南町",
        "column01": 772,
        "column02": 937,
        "column03": 385,
        "column04": 41.08858058,
        "column05": 1861,
        "column06": 1515,
        "column07": 1452,
        "column08": 2376,
        "column09": 3.29,
        "column10": 619,
        "column11": 1.58,
        "column12": 476,
        "column13": 2.61,
        "column14": 70,
        "column15": 2.27,
        "column16": 2620,
        "column17": 2580,
        "column18": 41,
        "column19": 0,
        "column20": 5,
        "column21": 1084,
        "column22": 4254,
        "column23": 77650,
        "column24": 839,
        "column25": 6942,
        "column26": 4437851,
        "column27": 153029.3448,
        "column28": 3570.274336,
        "column29": 29,
        "column30": 1243,
        "column31": 42.86206897,
        "column32": 14985,
        "column33": 138.75,
        "column34": 22.06921944,
        "column35": 108,
        "column36": 679,
        "column37": 6.287037037
      },
      {
        "citycode": 45406,
        "cityname": "都農町",
        "column01": 545,
        "column02": 654,
        "column03": 266,
        "column04": 40.67278287,
        "column05": 1330,
        "column06": 1062,
        "column07": 1010,
        "column08": 899,
        "column09": 1.73,
        "column10": 451,
        "column11": 0.82,
        "column12": 342,
        "column13": 1.11,
        "column14": 111,
        "column15": 1.35,
        "column16": 965,
        "column17": 956,
        "column18": 9,
        "column19": 1,
        "column20": 0,
        "column21": "x",
        "column22": "x",
        "column23": "x",
        "column24": "-",
        "column25": 7520,
        "column26": 2115946,
        "column27": 151139,
        "column28": 4353.798354,
        "column29": 14,
        "column30": 486,
        "column31": 34.71428571,
        "column32": 11065,
        "column33": 141.8589744,
        "column34": 23.64316239,
        "column35": 78,
        "column36": 468,
        "column37": 6
      },
      {
        "citycode": 45421,
        "cityname": "門川町",
        "column01": 305,
        "column02": 391,
        "column03": 65,
        "column04": 16.62404092,
        "column05": 652,
        "column06": 424,
        "column07": 380,
        "column08": 273,
        "column09": 0.98,
        "column10": 259,
        "column11": 0.89,
        "column12": 148,
        "column13": 0.13,
        "column14": 38,
        "column15": 0.66,
        "column16": 828,
        "column17": 493,
        "column18": 335,
        "column19": 0,
        "column20": 0,
        "column21": "-",
        "column22": "x",
        "column23": "x",
        "column24": "x",
        "column25": 3437,
        "column26": 1730312,
        "column27": 43257.8,
        "column28": 1188.401099,
        "column29": 40,
        "column30": 1456,
        "column31": 36.4,
        "column32": 18306,
        "column33": 102.8426966,
        "column34": 17.84210526,
        "column35": 178,
        "column36": 1026,
        "column37": 5.764044944
      },
      {
        "citycode": 45429,
        "cityname": "諸塚村",
        "column01": 280,
        "column02": 285,
        "column03": 33,
        "column04": 11.57894737,
        "column05": 421,
        "column06": 263,
        "column07": 225,
        "column08": 69,
        "column09": 0.43,
        "column10": 142,
        "column11": 0.29,
        "column12": 138,
        "column13": 0.12,
        "column14": 75,
        "column15": 0.17,
        "column16": 218,
        "column17": 0,
        "column18": 218,
        "column19": 0,
        "column20": 0,
        "column21": "-",
        "column22": 396,
        "column23": "-",
        "column24": "x",
        "column25": "x",
        "column26": "X",
        "column27": "x",
        "column28": "x",
        "column29": 4,
        "column30": 71,
        "column31": 17.75,
        "column32": 651,
        "column33": 34.26315789,
        "column34": 12.28301887,
        "column35": 19,
        "column36": 53,
        "column37": 2.789473684
      },
      {
        "citycode": 45430,
        "cityname": "椎葉村",
        "column01": 556,
        "column02": 503,
        "column03": 72,
        "column04": 14.31411531,
        "column05": 721,
        "column06": 439,
        "column07": 385,
        "column08": 147,
        "column09": 0.5,
        "column10": 273,
        "column11": 0.33,
        "column12": 250,
        "column13": 0.17,
        "column14": 73,
        "column15": 0.19,
        "column16": 276,
        "column17": 0,
        "column18": 276,
        "column19": 0,
        "column20": 0,
        "column21": "-",
        "column22": "x",
        "column23": "-",
        "column24": "x",
        "column25": "-",
        "column26": 79015,
        "column27": 15803,
        "column28": 1580.3,
        "column29": 5,
        "column30": 50,
        "column31": 10,
        "column32": 1596,
        "column33": 40.92307692,
        "column34": 12.46875,
        "column35": 39,
        "column36": 128,
        "column37": 3.282051282
      },
      {
        "citycode": 45431,
        "cityname": "美郷町",
        "column01": 908,
        "column02": 1114,
        "column03": 136,
        "column04": 12.20825853,
        "column05": 1701,
        "column06": 1037,
        "column07": 900,
        "column08": 707,
        "column09": 0.91,
        "column10": 725,
        "column11": 0.68,
        "column12": 426,
        "column13": 0.21,
        "column14": 241,
        "column15": 0.51,
        "column16": 1940,
        "column17": "－",
        "column18": 1940,
        "column19": "x",
        "column20": "x",
        "column21": "-",
        "column22": 1354,
        "column23": "x",
        "column24": "x",
        "column25": 3518,
        "column26": 101995,
        "column27": 11332.77778,
        "column28": 1062.447917,
        "column29": 9,
        "column30": 96,
        "column31": 10.66666667,
        "column32": 3443,
        "column33": 47.81944444,
        "column34": 13.39688716,
        "column35": 72,
        "column36": 257,
        "column37": 3.569444444
      },
      {
        "citycode": 45441,
        "cityname": "高千穂町",
        "column01": 1098,
        "column02": 1504,
        "column03": 354,
        "column04": 23.53723404,
        "column05": 2833,
        "column06": 1819,
        "column07": 1648,
        "column08": 1109,
        "column09": 1.03,
        "column10": 1052,
        "column11": 0.68,
        "column12": 764,
        "column13": 0.42,
        "column14": 185,
        "column15": 0.37,
        "column16": 2260,
        "column17": 0,
        "column18": 2260,
        "column19": 2,
        "column20": 44,
        "column21": "-",
        "column22": "x",
        "column23": "x",
        "column24": "x",
        "column25": 2218,
        "column26": 204215,
        "column27": 15708.84615,
        "column28": 1268.416149,
        "column29": 13,
        "column30": 161,
        "column31": 12.38461538,
        "column32": 18968,
        "column33": 93.9009901,
        "column34": 19.71725572,
        "column35": 202,
        "column36": 962,
        "column37": 4.762376238
      },
      {
        "citycode": 45442,
        "cityname": "日之影町",
        "column01": 567,
        "column02": 677,
        "column03": 124,
        "column04": 18.31610044,
        "column05": 1187,
        "column06": 706,
        "column07": 642,
        "column08": 398,
        "column09": 0.79,
        "column10": 470,
        "column11": 0.49,
        "column12": 302,
        "column13": 0.14,
        "column14": 263,
        "column15": 0.47,
        "column16": 838,
        "column17": 0,
        "column18": 838,
        "column19": "x",
        "column20": 23,
        "column21": "-",
        "column22": "x",
        "column23": "-",
        "column24": "x",
        "column25": "x",
        "column26": 160387,
        "column27": 17820.77778,
        "column28": 1145.621429,
        "column29": 9,
        "column30": 140,
        "column31": 15.55555556,
        "column32": 4161,
        "column33": 86.6875,
        "column34": 26.33544304,
        "column35": 48,
        "column36": 158,
        "column37": 3.291666667
      },
      {
        "citycode": 45443,
        "cityname": "五ヶ瀬町",
        "column01": 419,
        "column02": 598,
        "column03": 127,
        "column04": 21.23745819,
        "column05": 1054,
        "column06": 641,
        "column07": 593,
        "column08": 378,
        "column09": 0.96,
        "column10": 382,
        "column11": 0.59,
        "column12": 270,
        "column13": 0.33,
        "column14": 92,
        "column15": 0.7,
        "column16": 961,
        "column17": 0,
        "column18": 961,
        "column19": 0,
        "column20": 0,
        "column21": "-",
        "column22": "x",
        "column23": "x",
        "column24": "x",
        "column25": "-",
        "column26": 248819,
        "column27": 49763.8,
        "column28": 3231.415584,
        "column29": 5,
        "column30": 77,
        "column31": 15.4,
        "column32": 2486,
        "column33": 69.05555556,
        "column34": 17.50704225,
        "column35": 36,
        "column36": 142,
        "column37": 3.944444444
      }
    ]
};

export const jyuutaku = {
  ippan: {
    column: "column01",
    statName: '住宅に住む一般世帯',
    unit: '世帯',
  },
  data:
    [
      {
        "citycode": 45201,
        "cityname": "宮崎市",
        "column01": 173075,
        "column02": 386448,
        "column03": 99064,
        "column04": 56.62676773,
        "column05": 97346,
        "column06": 55.64472797,
        "column07": 9812,
        "column08": 245.9659528
      },
      {
        "citycode": 45202,
        "cityname": "都城市",
        "column01": 68907,
        "column02": 157880,
        "column03": 47583,
        "column04": 68.20273195,
        "column05": 53880,
        "column06": 77.22848911,
        "column07": 4292,
        "column08": 263.9492765
      },
      {
        "citycode": 45203,
        "cityname": "延岡市",
        "column01": 50939,
        "column02": 119900,
        "column03": 33452,
        "column04": 64.80182868,
        "column05": 35610,
        "column06": 68.98221688,
        "column07": 3728,
        "column08": 303.8379096
      },
      {
        "citycode": 45204,
        "cityname": "日南市",
        "column01": 22197,
        "column02": 51045,
        "column03": 16175,
        "column04": 71.63418955,
        "column05": 17609,
        "column06": 77.98494243,
        "column07": 2039,
        "column08": 386.6502323
      },
      {
        "citycode": 45205,
        "cityname": "小林市",
        "column01": 19061,
        "column02": 43722,
        "column03": 14788,
        "column04": 76.2071631,
        "column05": 16621,
        "column06": 85.65318217,
        "column07": 960,
        "column08": 212.2015915
      },
      {
        "citycode": 45206,
        "cityname": "日向市",
        "column01": 24331,
        "column02": 58846,
        "column03": 16076,
        "column04": 65.06131369,
        "column05": 18091,
        "column06": 73.216237,
        "column07": 1847,
        "column08": 302.0342752
      },
      {
        "citycode": 45207,
        "cityname": "串間市",
        "column01": 7843,
        "column02": 17564,
        "column03": 6299,
        "column04": 79.51274931,
        "column05": 6986,
        "column06": 88.18480182,
        "column07": 516,
        "column08": 283.8439958
      },
      {
        "citycode": 45208,
        "cityname": "西都市",
        "column01": 11898,
        "column02": 29333,
        "column03": 9116,
        "column04": 76.18888425,
        "column05": 9673,
        "column06": 80.84412871,
        "column07": 1057,
        "column08": 352.4743231
      },
      {
        "citycode": 45209,
        "cityname": "えびの市",
        "column01": 8459,
        "column02": 18736,
        "column03": 7011,
        "column04": 81.99041048,
        "column05": 7469,
        "column06": 87.34650918,
        "column07": 602,
        "column08": 320.1276256
      },
      {
        "citycode": 45341,
        "cityname": "三股町",
        "column01": 9827,
        "column02": 24370,
        "column03": 7373,
        "column04": 74.21238047,
        "column05": 8410,
        "column06": 84.65022647,
        "column07": 840,
        "column08": 330.4744669
      },
      {
        "citycode": 45361,
        "cityname": "高原町",
        "column01": 3878,
        "column02": 8977,
        "column03": 3451,
        "column04": 88.53258081,
        "column05": 3651,
        "column06": 93.66341714,
        "column07": 206,
        "column08": 228.1537269
      },
      {
        "citycode": 45382,
        "cityname": "国富町",
        "column01": 7437,
        "column02": 18349,
        "column03": 6148,
        "column04": 81.51683903,
        "column05": 6463,
        "column06": 85.69345001,
        "column07": 657,
        "column08": 341.1037849
      },
      {
        "citycode": 45383,
        "cityname": "綾町",
        "column01": 2889,
        "column02": 7120,
        "column03": 2229,
        "column04": 76.67698658,
        "column05": 2436,
        "column06": 83.79772962,
        "column07": 281,
        "column08": 391.6922219
      },
      {
        "citycode": 45401,
        "cityname": "高鍋町",
        "column01": 8594,
        "column02": 20100,
        "column03": 5430,
        "column04": 62.79634555,
        "column05": 6094,
        "column06": 70.47530936,
        "column07": 674,
        "column08": 325.8084788
      },
      {
        "citycode": 45402,
        "cityname": "新富町",
        "column01": 6248,
        "column02": 16291,
        "column03": 4575,
        "column04": 72.20643939,
        "column05": 4919,
        "column06": 77.63573232,
        "column07": 679,
        "column08": 402.1558872
      },
      {
        "citycode": 45403,
        "cityname": "西米良村",
        "column01": 504,
        "column02": 1047,
        "column03": 361,
        "column04": 71.06299213,
        "column05": 416,
        "column06": 81.88976378,
        "column07": 55,
        "column08": 524.8091603
      },
      {
        "citycode": 45404,
        "cityname": "木城町",
        "column01": 1928,
        "column02": 4969,
        "column03": 1528,
        "column04": 78.43942505,
        "column05": 1708,
        "column06": 87.67967146,
        "column07": 192,
        "column08": 373.3229633
      },
      {
        "citycode": 45405,
        "cityname": "川南町",
        "column01": 5817,
        "column02": 15313,
        "column03": 4673,
        "column04": 79.02925757,
        "column05": 5018,
        "column06": 84.86385929,
        "column07": 504,
        "column08": 321.9830065
      },
      {
        "citycode": 45406,
        "cityname": "都農町",
        "column01": 3912,
        "column02": 10152,
        "column03": 3244,
        "column04": 82.58655804,
        "column05": 3431,
        "column06": 87.34725051,
        "column07": 423,
        "column08": 411.9996104
      },
      {
        "citycode": 45421,
        "cityname": "門川町",
        "column01": 6718,
        "column02": 17370,
        "column03": 5133,
        "column04": 75.48529412,
        "column05": 5479,
        "column06": 80.57352941,
        "column07": 674,
        "column08": 376.6625685
      },
      {
        "citycode": 45429,
        "cityname": "諸塚村",
        "column01": 661,
        "column02": 1666,
        "column03": 501,
        "column04": 73.03206997,
        "column05": 576,
        "column06": 83.96501458,
        "column07": 34,
        "column08": 206.5613609
      },
      {
        "citycode": 45430,
        "cityname": "椎葉村",
        "column01": 1118,
        "column02": 2700,
        "column03": 901,
        "column04": 80.08888889,
        "column05": 1001,
        "column06": 88.97777778,
        "column07": 88,
        "column08": 329.588015
      },
      {
        "citycode": 45431,
        "cityname": "美郷町",
        "column01": 2323,
        "column02": 5255,
        "column03": 1969,
        "column04": 84.68817204,
        "column05": 2231,
        "column06": 95.95698925,
        "column07": 144,
        "column08": 275.124188
      },
      {
        "citycode": 45441,
        "cityname": "高千穂町",
        "column01": 4616,
        "column02": 12068,
        "column03": 3577,
        "column04": 76.64452539,
        "column05": 3921,
        "column06": 84.01542747,
        "column07": 204,
        "column08": 164.410058
      },
      {
        "citycode": 45442,
        "cityname": "日之影町",
        "column01": 1487,
        "column02": 3824,
        "column03": 1278,
        "column04": 85.82941572,
        "column05": 1385,
        "column06": 93.01544661,
        "column07": 91,
        "column08": 236.4864865
      },
      {
        "citycode": 45443,
        "cityname": "五ヶ瀬町",
        "column01": 1270,
        "column02": 3581,
        "column03": 1071,
        "column04": 84.19811321,
        "column05": 1178,
        "column06": 92.61006289,
        "column07": 54,
        "column08": 146.8588523
      }
    ]
};


export const syaho = {
  seihohihogo: {
    column: "column01",
    statName: '生活保護費保護世帯数',
    unit: '世帯',
  },
  seihohihogo100atari: {
    column: "column02",
    statName: '100世帯あたり生活保護費保護世帯数',
    unit: '世帯',
  },
  seihohihogozitu: {
    column: "column03",
    statName: '生活保護費保護実人員',
    unit: '人',
  },
  seihohihogozitu1000atari: {
    column: "column04",
    statName: '人口千人あたり生活保護費保護実人員',
    unit: '人',
  },
  kaigowariai: {
    column: "column05",
    statName: '介護保険第1号被保険者に占める認定者割合',
    unit: '％',
  },
  kaigo1atari: {
    column: "column06",
    statName: '介護保険受給者１人当たり費用額（年平均1か月）',
    unit: '千円',
  },
  nenkinsuu: {
    column: "column07",
    statName: '国民年金被保険者数',
    unit: '人',
  },
  reoureizyukyuu: {
    column: "column08",
    statName: '老齢年金受給権者状況',
    unit: '件',
  },
  reoureiheikin: {
    column: "column09",
    statName: '老齢年金平均年金額',
    unit: '円',
  },
  data:
    [
      {
        "citycode": 45201,
        "cityname": "宮崎市",
        "column01": 6890,
        "column02": 3.58,
        "column03": 8899,
        "column04": 22.01,
        "column05": 16.4,
        "column06": 144.1,
        "column07": 78483,
        "column08": 97292,
        "column09": 651840,
        "column10": 9,
        "column11": 0.01
      },
      {
        "citycode": 45202,
        "cityname": "都城市",
        "column01": 1354,
        "column02": 1.73,
        "column03": 1728,
        "column04": 10.33,
        "column05": 19,
        "column06": 136.5,
        "column07": 28514,
        "column08": 47079,
        "column09": 670607,
        "column10": "－",
        "column11": "－"
      },
      {
        "citycode": 45203,
        "cityname": "延岡市",
        "column01": 2208,
        "column02": 3.71,
        "column03": 2761,
        "column04": 21.81,
        "column05": 20,
        "column06": 131.1,
        "column07": 20783,
        "column08": 37533,
        "column09": 632523,
        "column10": "－",
        "column11": "－"
      },
      {
        "citycode": 45204,
        "cityname": "日南市",
        "column01": 533,
        "column02": 1.98,
        "column03": 687,
        "column04": 12.49,
        "column05": 19.7,
        "column06": 128.7,
        "column07": 8367,
        "column08": 18323,
        "column09": 660848,
        "column10": "－",
        "column11": "－"
      },
      {
        "citycode": 45205,
        "cityname": "小林市",
        "column01": 454,
        "column02": 2.05,
        "column03": 571,
        "column04": 12.13,
        "column05": 19.4,
        "column06": 143.5,
        "column07": 7683,
        "column08": 15196,
        "column09": 677487,
        "column10": 1,
        "column11": 0.01
      },
      {
        "citycode": 45206,
        "cityname": "日向市",
        "column01": 740,
        "column02": 2.58,
        "column03": 917,
        "column04": 14.61,
        "column05": 14.4,
        "column06": 147.7,
        "column07": 10210,
        "column08": 17167,
        "column09": 635346,
        "column10": "－",
        "column11": "－"
      },
      {
        "citycode": 45207,
        "cityname": "串間市",
        "column01": 161,
        "column02": 1.74,
        "column03": 194,
        "column04": 10.08,
        "column05": 17.6,
        "column06": 145.3,
        "column07": 2992,
        "column08": 7034,
        "column09": 665590,
        "column10": "－",
        "column11": "－"
      },
      {
        "citycode": 45208,
        "cityname": "西都市",
        "column01": 282,
        "column02": 2.04,
        "column03": 346,
        "column04": 11.07,
        "column05": 16.7,
        "column06": 160.3,
        "column07": 5628,
        "column08": 10476,
        "column09": 661320,
        "column10": "－",
        "column11": "－"
      },
      {
        "citycode": 45209,
        "cityname": "えびの市",
        "column01": 239,
        "column02": 2.38,
        "column03": 308,
        "column04": 15.14,
        "column05": 20.8,
        "column06": 140.8,
        "column07": 2964,
        "column08": 7579,
        "column09": 673820,
        "column10": "－",
        "column11": "－"
      },
      {
        "citycode": 45341,
        "cityname": "三股町",
        "column01": 159,
        "column02": 1.44,
        "column03": 222,
        "column04": 8.52,
        "column05": 17.8,
        "column06": 140.8,
        "column07": 4479,
        "column08": 6271,
        "column09": 675841,
        "column10": 1,
        "column11": 0.02
      },
      {
        "citycode": 45361,
        "cityname": "高原町",
        "column01": 68,
        "column02": 1.5,
        "column03": 82,
        "column04": 8.46,
        "column05": 15.5,
        "column06": 153.4,
        "column07": 1504,
        "column08": 3570,
        "column09": 692172,
        "column10": "－",
        "column11": "－"
      },
      {
        "citycode": 45382,
        "cityname": "国富町",
        "column01": 179,
        "column02": 2,
        "column03": 217,
        "column04": 10.87,
        "column05": 17.1,
        "column06": 147,
        "column07": 3772,
        "column08": 6367,
        "column09": 673395,
        "column10": "－",
        "column11": "－"
      },
      {
        "citycode": 45383,
        "cityname": "綾町",
        "column01": 45,
        "column02": 1.38,
        "column03": 56,
        "column04": 7.41,
        "column05": 15.3,
        "column06": 165.8,
        "column07": 1391,
        "column08": 2425,
        "column09": 680373,
        "column10": "－",
        "column11": "－"
      },
      {
        "citycode": 45401,
        "cityname": "高鍋町",
        "column01": 253,
        "column02": 2.65,
        "column03": 335,
        "column04": 16.01,
        "column05": 13.3,
        "column06": 145.6,
        "column07": 3695,
        "column08": 6260,
        "column09": 672180,
        "column10": "－",
        "column11": "－"
      },
      {
        "citycode": 45402,
        "cityname": "新富町",
        "column01": 137,
        "column02": 1.79,
        "column03": 202,
        "column04": 11.35,
        "column05": 12.6,
        "column06": 170,
        "column07": 3361,
        "column08": 4940,
        "column09": 690251,
        "column10": "－",
        "column11": "－"
      },
      {
        "citycode": 45403,
        "cityname": "西米良村",
        "column01": 7,
        "column02": 1.17,
        "column03": 11,
        "column04": 9.1,
        "column05": 16.8,
        "column06": 135.3,
        "column07": 128,
        "column08": 501,
        "column09": 688014,
        "column10": "－",
        "column11": "－"
      },
      {
        "citycode": 45404,
        "cityname": "木城町",
        "column01": 36,
        "column02": 1.58,
        "column03": 43,
        "column04": 8.04,
        "column05": 17.5,
        "column06": 145.1,
        "column07": 838,
        "column08": 1774,
        "column09": 686436,
        "column10": "－",
        "column11": "－"
      },
      {
        "citycode": 45405,
        "cityname": "川南町",
        "column01": 111,
        "column02": 1.64,
        "column03": 138,
        "column04": 8.56,
        "column05": 14.7,
        "column06": 148.7,
        "column07": 2904,
        "column08": 5101,
        "column09": 684334,
        "column10": "－",
        "column11": "－"
      },
      {
        "citycode": 45406,
        "cityname": "都農町",
        "column01": 87,
        "column02": 1.87,
        "column03": 128,
        "column04": 11.83,
        "column05": 15.2,
        "column06": 137.9,
        "column07": 1842,
        "column08": 3710,
        "column09": 669250,
        "column10": "－",
        "column11": "－"
      },
      {
        "citycode": 45421,
        "cityname": "門川町",
        "column01": 225,
        "column02": 2.78,
        "column03": 278,
        "column04": 15.08,
        "column05": 15.7,
        "column06": 125.1,
        "column07": 2949,
        "column08": 5411,
        "column09": 642867,
        "column10": "－",
        "column11": "－"
      },
      {
        "citycode": 45429,
        "cityname": "諸塚村",
        "column01": 7,
        "column02": 0.95,
        "column03": 8,
        "column04": 4.36,
        "column05": 16.1,
        "column06": 137.9,
        "column07": 242,
        "column08": 2655,
        "column09": 690776,
        "column10": "－",
        "column11": "－"
      },
      {
        "citycode": 45430,
        "cityname": "椎葉村",
        "column01": 27,
        "column02": 2.19,
        "column03": 31,
        "column04": 10.53,
        "column05": 17.3,
        "column06": 127.2,
        "column07": 436,
        "column08": 719,
        "column09": 712280,
        "column10": "－",
        "column11": "－"
      },
      {
        "citycode": 45431,
        "cityname": "美郷町",
        "column01": 54,
        "column02": 1.97,
        "column03": 70,
        "column04": 12.09,
        "column05": 17.7,
        "column06": 163.1,
        "column07": 762,
        "column08": 1195,
        "column09": 628322,
        "column10": "－",
        "column11": "－"
      },
      {
        "citycode": 45441,
        "cityname": "高千穂町",
        "column01": 90,
        "column02": 1.77,
        "column03": 102,
        "column04": 7.99,
        "column05": 13.7,
        "column06": 135,
        "column07": 1754,
        "column08": 4762,
        "column09": 671136,
        "column10": "－",
        "column11": "－"
      },
      {
        "citycode": 45442,
        "cityname": "日之影町",
        "column01": 35,
        "column02": 2.04,
        "column03": 48,
        "column04": 11.48,
        "column05": 16.1,
        "column06": 161.7,
        "column07": 552,
        "column08": 1738,
        "column09": 695589,
        "column10": "－",
        "column11": "－"
      },
      {
        "citycode": 45443,
        "cityname": "五ヶ瀬町",
        "column01": 23,
        "column02": 1.44,
        "column03": 29,
        "column04": 7.1,
        "column05": 14.6,
        "column06": 150.1,
        "column07": 530,
        "column08": 1518,
        "column09": 658192,
        "column10": "－",
        "column11": "－"
      }
    ]
};
